import React from 'react'
import styles from './emailSenderModal.scss'
import i18n from 'lib/i18n'
import cs from 'classnames'
import {hideEmailSenderModal, setEmailSenderModule, fetchOfficeData, showEmailSenderConfirmationModal,
    hideEmailSenderConfirmationModal, showEmailSenderAttachmentModal, hideEmailSenderAttachmentModal,
    sendEmailBySender, preCacheDocuments, setNotification, setAppModule, getOutbox, localUploadHandler,
    setEmailSenderExternalAttachments, loadEmailRecentRecipients, addEmailRecentRecipients,
    removeEmailRecentRecipients, loadEmailServer, showEmailServerConfigModal,hideEmailServerConfigModal, saveEmailServer} from 'state/actions'
import {isAnEmail} from 'lib/validator'
import {reduxForm} from 'redux-form'
import reactStringReplace from 'react-string-replace'

// import tinyMCE. The 5.3 or above also requires importing a theme and a set of icons
import tinymce from 'tinymce/tinymce'
import 'tinymce/icons/default';
import 'tinymce/themes/silver'

// For tinyMCE 5.3 or above, the plugins are now imported here instead of being specified
// as external scripts
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/code'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/table'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'


import {connect} from 'react-redux'
import underscore from 'underscore'
import nesProp from 'nested-property'
import SelectWrapper from '../shared/select/SelectWrap'
import EmailAddressComposer, {DropdownIndicator, customCreatableSelectStyles} from './emailAddressComposer'
import ConfirmationDialog from './confirmationDialog'
import AttachmentDialog from './attachmentDialog'
import c from 'state/constants'
import moment from 'moment'
import {fetchSrcValuesFromHtml} from './helpers.jsx'
//import {WillemotEmails} from '../environments.coffee'

import {components as reactSelectComponents} from 'react-select'
import ReactSelect2, { createFilter } from 'react-select'
import EmailServerConfigDialog from './emailServerConfigDialog'

const _ = i18n('emailSender')
const listOfFields = ["recipientField","emailTemplateField","emailLanguageField","emailFromField","emailToSelectField",
    "emailToSelectFieldCC","subjectField", "emailBodyField", "signatureField", "attachmentsForValidateOnly", "brokerField"]
/* const listOfRequiredFields = ["recipientField", "emailFromField", "emailToSelectField",
    "subjectField", "emailBodyField"] */
let brokerFieldIsRequired = false

let DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY = "linkPlaceholder"
let DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY = "fullNamePlaceholder"
// let DISCLAIMER_PLACEHOLDER_TRANS_KEY = "disclaimerPlaceholder"

let DSWIZARD_DISCLAIMER_RESTRICTED_TEMPLATE_SET = "coupure 212"
const EMAIL_TYPE_QUICK_REPLY = "EMAIL_TYPE_QUICK_REPLY"
const EMAIL_TYPE_DEFAULT = "EMAIL_TYPE_DEFAULT"

/**
 * Custom dropdown indicator for react-select to be the similar style lik emailFromField: _('emailFromFieldServerConfigMissing')
 */
export const NoOptionsMessageForTemplateSelector = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.NoOptionsMessage {...props}>
        {_('noTemplateOptions')}
      </reactSelectComponents.NoOptionsMessage>
    )
}

/**
 * Validation function for react form when checking email components.
 * @param {array} values
 * @param {object} extraConditions - structure: {<fieldName as  property name>: { error: <string> }}
 */
const validate = (values, extraConditions = null) => {

    const errors = {}
    // recipientField not be empty
    if (brokerFieldIsRequired && underscore.isEmpty(values.brokerField)) {
		errors.brokerField = _('brokerFieldIsRequired')
    }

    // recipientField not be empty
    if (underscore.isEmpty(values.recipientField)) {
		errors.recipientField = _('recipientFieldIsRequired')
    }

    // emailFromField not to be empty
    if (underscore.isEmpty(values.emailFromField)) {
		errors.emailFromField = _('emailFromFieldIsRequired')
	}

    // minimum one to address is required for emailToSelectField
    if (underscore.isEmpty(values.emailToSelectField)) {
		errors.emailToSelectField = _('youHaveToGiveMinimumOneEmail')
    }

    // If not empty have to validate
	if (!underscore.isEmpty(values.emailToSelectField) && values.emailToSelectField.length === 0 ) {
		errors.emailToSelectField = _('youHaveToGiveMinimumOneEmail')
    }

    // emailToSelectField if not empty have to validate
	if (!underscore.isEmpty(values.emailToSelectField)) {
        let hasErrorAnError = false

        values.emailToSelectField.forEach((item)=>{
            if(item && item.value && (typeof item.value === 'string') && item.value.trim()) return
            hasErrorAnError = hasErrorAnError || (item && item.value && item.value.length == 0)
        })

        if (hasErrorAnError) {
            errors.emailToSelectField = _("youHaveToGiveMinimumOneEmail")
        } else {

            values.emailToSelectField.forEach((item) => {
                hasErrorAnError = hasErrorAnError ||
                    (item && item.value && (typeof item.value === 'string') && !isAnEmail(item.value.trim()))
            })

            if (hasErrorAnError) {
                errors.emailToSelectField = _("invalidInputEmailTo")
            }
        }
    }

    // emailToSelectFieldCC if not empty have to validate
	if (!underscore.isEmpty(values.emailToSelectFieldCC)) {
        let hasErrorAnError = false

        values.emailToSelectFieldCC.forEach((item) => {
            hasErrorAnError = hasErrorAnError ||
                (item && item.value && (typeof item.value === 'string') && !isAnEmail(item.value.trim()))
        })

        if (hasErrorAnError) {
            errors.emailToSelectFieldCC = _("invalidInputEmailToCC")
        }

    }

    // subjectField cant be not empty
    if (underscore.isEmpty(values.subjectField)) {
		errors.subjectField = _('emailBodyFieldIsRequired')
    }

    // emailBodyField cant be not empty
    if (underscore.isEmpty(values.emailBodyField)) {
		errors.emailBodyField = _('emailBodyFieldIsRequired')
    }

    // ++++++ check MULTI LANGUAGE and link obligation
    // this validation is differ by the dedicated validation of the redux-form because
    // depends on external values of the form, what can't be passed for
    if (extraConditions) {

        let extraEmailBodyError = ""
        if (extraConditions.multiLanguage && extraConditions.stakeholders) {
            let langMap =  extraConditions.stakeholders.map(one => one.language)

            // Make sure if the link placeholder exists
            if (langMap.some((one)=>(String(one).toLocaleLowerCase() === 'nl'))) {
                let translatedPHolder = _(DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY, "nl")
                if (!String(extraConditions.nlBody).includes(translatedPHolder)) {
                    // make sure the field exists
                    extraEmailBodyError = _("privateLinkPlaceholderMissingOnNl")
                }
            }

            // Make sure if the link placeholder exists
            if (langMap.some((one)=>(String(one).toLocaleLowerCase() === 'fr'))) {
                let translatedPHolder = _(DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY, "fr")
                if (!String(extraConditions.frBody).includes(translatedPHolder)) {
                    // make sure the field exists
                    extraEmailBodyError = _("privateLinkPlaceholderMissingOnFr")
                }
            }
        }

        // set the error for the field
        if (extraEmailBodyError) {
            errors.emailBodyField = extraEmailBodyError
        }
    }
    // ----------------------------------------------------------

    // all attachments alias names must be valid
    if (!underscore.isEmpty(values.attachmentsForValidateOnly)) {
        values.attachmentsForValidateOnly.forEach((item) => {
            if (item.aliasFileName && item.aliasFileName.trim()) {
                if (item.aliasFileName.length > 250) {
                    errors.attachmentsForValidateOnly = _('attachmentAliasNameTooLong') + " " + item.aliasFileName
                } else {
                    const regexExceptions = /[\/\\\%\|\<\>\"\:\?]+/g
                    const foundNotAllowed = item.aliasFileName.match(regexExceptions)

                    if (foundNotAllowed && foundNotAllowed.length > 0) {
                        errors.attachmentsForValidateOnly = _('attachmentAliasNameContainsNotAllowed') + " " + item.aliasFileName
                    }
                }
            } else {
                errors.attachmentsForValidateOnly = _('attachmentAliasCanNotEmpty')
            }
        })
    }

    return errors
}

// this is out of order, if editor is working correctly should remove the
// "actualCaretPositionBookmark" variable
// Variables outside the module
// let actualCaretPositionBookmark = 0

/**
 * Email sender form component for composing emails.
 */
@reduxForm({
	form: "emailSender",
    fields: listOfFields,
    validate,
	// asyncValidate,
    // asyncBlurFields: ['emailFromField'],

	destroyOnUnmount: true,
    touchOnBlur: true,
    // validateOnBlur: true,

    //  asyncValidating: true
})
class SenderForm extends React.Component {
	static propTypes = {
		fields: React.PropTypes.object.isRequired,
		options: React.PropTypes.object.isRequired,
		dataCallback: React.PropTypes.func,
		dataCallbackDisableSend: React.PropTypes.func,
		setDisclaimerForPreview: React.PropTypes.func,
		onSentLate: React.PropTypes.func,
		isCreatable: React.PropTypes.bool,
		forceIsMulti: React.PropTypes.bool,
		haveDisclaimer: React.PropTypes.bool
    }

    constructor(props) {
        super(props)

        this.state = {
            theBodyEditor: null,
            templateContent: '',
            brokerOptions: [],
            templatesOptions: [],
            templateRecipients: [],
            emailToOptions: [],
            emailFromOptions: [],
            selectedEmailFromName: '',
            langOptions: [],
            signatureOptions: [],
            variables: [],
            attachments: [],
            finalEmail: {},
            moduleOptions: {},
            moduleSpecificClaimAttachemnts: [],
            moduleSpecificContractAttachemnts: [],
            moduleSpecificClientAttachemnts: [],
            moduleSpecificTarificationAttachemnts: [],
            moduleSpecificTicketAttachemnts: [],
            hardAttachments: [], // this documents will attached like real attachments not only links
            lastError: false,
            precacheInProgress: false,
            isCCShown: false,
            emailServerConfigError: '',

            // the followings are used only when the language is selectable:
            activeLanguageTabValue: '',
            nlLanguageTabBodyValue: null,
            nlLanguageTabSubjectValue: null,
            frLanguageTabBodyValue: null,
            frLanguageTabSubjectValue: null
        }
    }

    /**
     * This function triggered when the module was mounted.
     */
    async componentDidMount () {
        let {dispatch, options:{moduleOptions}} = this.props

        // when the email editor must initialized with values provided by another module like inbox.
        let initResult = await this.processArgumentInitialValue()
        let hardAttachments = initResult.hardAttachments

        // must get the office data for all informations for variables
        // removed this functionality as it never worked and now causes the module to crash
        //await dispatch(fetchOfficeData())

        let baseModuleOptions = this.getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions, moduleOptions.brokerNumber)

        let mergeResult = this.initAndMixPropsToModuleOptionsState(moduleOptions, baseModuleOptions)
        moduleOptions = mergeResult.moduleOptions

        // get the recently used email addresses to extend the recipient list
        if (moduleOptions.brokerNumber) {
            let emailRecentRecipientsResult = await dispatch(loadEmailRecentRecipients(moduleOptions.brokerNumber))

            baseModuleOptions = this.getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions)
            baseModuleOptions.emailRecentRecipients = emailRecentRecipientsResult

            mergeResult = this.initAndMixPropsToModuleOptionsState(moduleOptions, baseModuleOptions)

            moduleOptions = mergeResult.moduleOptions
        }

        this.setupTinyMCE()
        mergeResult = this.initAndMixPropsToModuleOptionsState(moduleOptions, baseModuleOptions)
        moduleOptions = mergeResult.moduleOptions

        this.initializeLanguage(moduleOptions.clientLanguage)

        let brokerOptions = this.initializeBrokerOptions(moduleOptions.brokerNumber)
        let templatesOptions = this.initializeTemplateOptions()

        // preselect brokerEmail
        if (moduleOptions.brokerEmailAddress) {
            // this.onChangeEmailFromAddress({value: moduleOptions.brokerEmailAddress})
            // moduleOptions = this.do TheBrokerChange(moduleOptions, {value: moduleOptions.brokerNumber})
            this.updateFormValue({value: moduleOptions.brokerEmailAddress}, this.props.fields.emailFromField)

        }

        // preselect template
        if (moduleOptions.autoSelectTemplate) {
            //this.updateFormValue({value: "0"}, this.props.fields.emailTemplateField)
            this.doTheTemplateSwitch(moduleOptions.brokerNumber, moduleOptions.clientLanguage, {value: "0"}, moduleOptions.brokerEmailAddress)
        }

        this.initializeSignatures(moduleOptions.brokerNumber)

        let preapredAttachments = moduleOptions.ticketDocuments && moduleOptions.ticketDocuments.map(oneAttachment => ({
            ...oneAttachment,
            aliasFileName: this.getDefaultAliasForFileNameInAttachments(oneAttachment.name, oneAttachment.date, oneAttachment.id)
        })) || []

        // once to do the set state at the end of hook (if it possible)
        this.setState({
            hardAttachments,
            moduleOptions,
            brokerOptions,
            templatesOptions,
            activeLanguageTabValue: this.state.activeLanguageTabValue || moduleOptions.clientLanguage,
            moduleSpecificTicketAttachemnts: preapredAttachments,
            attachments: preapredAttachments,
        })
    }

    /**
     * Handle props changes to map values in state
     * @param {*} nextProps
     */
    componentWillReceiveProps  (nextProps) {

        // +++ TICKED DOCUMENTS set all selected by default if the moduleKey is inboxReplyToWillemot +++
        let moduleKey = nesProp.get(nextProps, "options.moduleKey")
        let EmailTemplateRelations = nesProp.get(nextProps, "options.EmailTemplateRelations")

        if (moduleKey == EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value) {
            let nextTicketDocuments = nesProp.get(nextProps, "options.moduleOptions.ticketDocuments") || []
            let currentTicketDocuments = nesProp.get(this.props, "options.moduleOptions.ticketDocuments") || []

            if (JSON.stringify(nextTicketDocuments) !== JSON.stringify(currentTicketDocuments)) {
                let currentStateTicketDocuments = nesProp.get(this.state, "moduleSpecificTicketAttachemnts") || []

                if (JSON.stringify(nextTicketDocuments) !== JSON.stringify(currentStateTicketDocuments)) {
                    this.setState({ moduleSpecificTicketAttachemnts: nextTicketDocuments })
                }
            }
        }
        // --- END handle the change of the moduleOptions.ticketDocuments ---

    }

    /**
     * Using the values for initialization what are coming from other modules like inbox
     */
    async processArgumentInitialValue() {
        const {dispatch, options: {externalAttachments}} = this.props
        let hardAttachments = []

        // must generate aliases and extend the document list to be able the user to edit the name before send
        if (externalAttachments && externalAttachments.length > 0) {
            externalAttachments.forEach((item, index) => {
                hardAttachments.push({
                    ...item,
                    aliasFileName: this.getDefaultAliasForFileNameInAttachments(item.name, item.date, item.id), // sync call
                })
            })
        }

        // set hard attachments. This time this is the only way to add real attachments for mails
        hardAttachments = hardAttachments || []

        // hard attachment precache
        if (!underscore.isEmpty(hardAttachments)) {
            let extendedAttachments = await this.doThePrecache(hardAttachments)
            hardAttachments = extendedAttachments.filter((oneAttachment)=>Boolean(oneAttachment.localId))
        }

        await dispatch(setEmailSenderExternalAttachments(null))

        return {
            hardAttachments,
        }
    }

    /**
     * This function will update the moduleOptions state property by store if there are changes.
     * The moduleOption is a set of
     * @param {object} moduleOptionByProps
     * @param {object} moduleOptionsNewState
     * @returns {bool} true if the set state was called, false if not because nothing changed
     */
    initAndMixPropsToModuleOptionsState(moduleOptionByProps, moduleOptionsNewState) {
        // must use this to do not overwrite the original value fo parameter
        moduleOptionByProps = moduleOptionByProps || {}

        // clone and clean to be able compare the differences what requires to update state of "module options"
        // because the async api calls pass values after modal was initialized, and here must handle the changes
        const incomingPropsWithoutBrokerRelated = JSON.parse(JSON.stringify(moduleOptionByProps))
        delete incomingPropsWithoutBrokerRelated.officeContract
        delete incomingPropsWithoutBrokerRelated.commercialOfficeName
        delete incomingPropsWithoutBrokerRelated.brokerNumber
        delete incomingPropsWithoutBrokerRelated.emailRecentRecipients

        const nextStateWithoutBrokerRelated = JSON.parse(JSON.stringify(moduleOptionsNewState))
        delete nextStateWithoutBrokerRelated.officeContract
        delete nextStateWithoutBrokerRelated.commercialOfficeName
        delete nextStateWithoutBrokerRelated.brokerNumber
        delete nextStateWithoutBrokerRelated.emailRecentRecipients

        // the broker number used from props if in the state is empty
        let mustBeTheBrokerNumber = moduleOptionsNewState && moduleOptionsNewState.brokerNumber
        if (moduleOptionByProps.brokerNumber && (!mustBeTheBrokerNumber)) {
            mustBeTheBrokerNumber = moduleOptionByProps.brokerNumber
        }

        // update state if there are changes or the brokerNumber update, else does not change values to
        // prevent triggering of component update
        let wasAChange = false
        if (JSON.stringify(incomingPropsWithoutBrokerRelated) !== JSON.stringify(nextStateWithoutBrokerRelated)
            || (moduleOptionsNewState.brokerNumber !== mustBeTheBrokerNumber)
            || this.state.moduleOptions.officeContract !== moduleOptionsNewState.officeContract
            || this.state.moduleOptions.commercialOfficeName !== moduleOptionsNewState.commercialOfficeName
            || JSON.stringify(this.state.moduleOptions.emailRecentRecipients) !== JSON.stringify(moduleOptionsNewState.emailRecentRecipients)
        ) {
            // was changed to avoid to do the next stuffs in the componentWillUpdate hook
            wasAChange = true
        }

        // init the result with original state values
        let newModuleOptions = JSON.parse(JSON.stringify(moduleOptionsNewState))

        // if was changes put it to the result
        if (wasAChange) {
            newModuleOptions = {
                ...incomingPropsWithoutBrokerRelated,
                officeContract: moduleOptionsNewState && moduleOptionsNewState.officeContract,
                commercialOfficeName: moduleOptionsNewState && moduleOptionsNewState.commercialOfficeName,
                emailRecentRecipients: moduleOptionsNewState && moduleOptionsNewState.emailRecentRecipients,
                brokerNumber: mustBeTheBrokerNumber,
            }
        }

        return {
            moduleOptions: newModuleOptions,
            wasAChange
        }
    }

    /**
     * This function will initialize the language field in form.
     */
    initializeLanguage(clientLanguage) {
        // we have to initialize the language of the curent template to the broker prefered language
        const initialEmailLang = this.fetchRecipientLanguage(clientLanguage)
        const {fields} = this.props

        this.updateFormValue({value: initialEmailLang}, fields.emailLanguageField)
    }

    /**
     * This function will initialize the signature field. Selecting the default signature,
     * or the first one if there are no default signature.
     */
    initializeSignatures(brokerNumber) {
        const {signatures} = this.props.options
        const {fields} = this.props
        const {moduleOptions} = this.state
        const isOffice = moduleOptions && moduleOptions.dsPackage && moduleOptions.dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE

        // compose value for hold "id" and "html" for preview and keep Id also
        // try to get the default signature by filtering broker number and isDefault
        let initialSignature = signatures && signatures.filter((val)=>{
            return val.isDefault && (val.brokerNumber == brokerNumber || !brokerNumber)
        }) || false

        // after filtering only one element remains, fetch from array because that is the first one
        // as per BEWB 781 if package from office don't show signature
        initialSignature = initialSignature && initialSignature.length > 0 && initialSignature[0] || false
        let signatureId = initialSignature && !isOffice ? initialSignature._id : ''

        this.updateFormValue({value: signatureId}, fields.signatureField)
    }

    /**
     * This function will set state for the template selector input.
     * Insert the list of templates like an array contains plain JS objects (label, value).
     */
    initializeTemplateOptions() {
        const {options: {templates, lang}} = this.props
        const templatesOptions = templates && templates.map((templateValue, templateIndex)=>({
            value: String(templateIndex),
            label: templateValue.title[lang]
        }))
        .sort((templateA, templateB)=>{
            if (templateA.label < templateB.label) { return -1 }
            if (!templateA.label > templateB.label) { return 1 }
            if (templateA.label === templateB.label) { return 0 }
        })

        return templatesOptions
    }

    /**
     * This function will set state for the broker selector input.
     * Insert the list of broker like an array contains plain JS objects (label, value).
     * @param {*} forceBrokerNumber On contracts module we have preselected broker number depending on contract
     */
    initializeBrokerOptions(forceBrokerNumber) {
        const {options: {brokers}, fields: {brokerField}} = this.props
        let usedBrokerIndex = 0;
        const brokerOptions = brokers && Object.keys(brokers).map((brokerKey, index) => {

            // find the index of the used broker from options
            if (brokers[brokerKey].brokerNumber === forceBrokerNumber) {
                usedBrokerIndex = index
            }

            // transform raw broker info into selectable option for dropdowns
            return {
                value: brokerKey,
                label: brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name
            }
        })

        //implemented a default broker value
        if(brokerField && !brokerField.value ) {
            this.onChangeBroker({
                value: brokerOptions[usedBrokerIndex].value
            })
        }

        return brokerOptions
    }

    /**
	 * We have to reset the references because the editors will reinitialize on mount.
	 */
	componentWillUnmount () {
       this.unmountTinyMCE()
    }

    /**
     * This function handle the touch event, to trigger blur.
     * @param {*} field
     */
	touch(field) {
		//field.onBlur()
    }

    /**
     * Only place where we use the module options from props.options because that contains only
     * the incoming data, but the in the this.state.moduleOptions we extend by a few other common value
     * what are the same role.
     */
    getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions, forcedBrokerNumber = null) {
        const {office} = this.props.options

        // override forced the broker number if that is set in arguments list
        let determinedBrokerNumber = forcedBrokerNumber || (moduleOptions && moduleOptions.brokerNumber)
        // when the parameter is an empty string we have to set empty value for the selected brokerNumber
        if (typeof forcedBrokerNumber == 'string' && forcedBrokerNumber === '') {
            determinedBrokerNumber = forcedBrokerNumber
        }

        // clone the moduleOptions
        const newModuleOptions = JSON.parse(JSON.stringify(moduleOptions))

        // get the brokers office info and put it in the moduleOption
        newModuleOptions.officeContract = determinedBrokerNumber ? nesProp.get(office, "brokers."+determinedBrokerNumber+".main.contractType") : ''
        newModuleOptions.commercialOfficeName = determinedBrokerNumber ? nesProp.get(office, "brokers."+determinedBrokerNumber+".main.commercialName") : ''
        newModuleOptions.company = moduleOptions.company || ''
        newModuleOptions.brokerNumber = determinedBrokerNumber

        return newModuleOptions
    }

    /**
     * Generate valid fresh value for using the selected template
     * @param {*} emailTemplateFieldValue
     */
    getNewSelectedTemplate(emailTemplateFieldValue) {
        const {options: {templates}} = this.props

        let selectedTemplate = !underscore.isEmpty(templates) &&
            (!underscore.isEmpty(emailTemplateFieldValue) || emailTemplateFieldValue === "0") &&
            templates.filter((template, templateIndex)=> (String(templateIndex) === emailTemplateFieldValue)) || false

        //if ((!selectedTemplate || selectedTemplate.length === 0) && )

        selectedTemplate = !underscore.isEmpty(selectedTemplate) && selectedTemplate[0] || false

        return selectedTemplate
    }

    /**
     * Generate value for template content
     * @param {*} selectedTemplate
     */
    getNewTemplateContent(selectedTemplate) {
        let templateContent = false
        try {
            templateContent = selectedTemplate && selectedTemplate.templateContent &&
                JSON.parse(selectedTemplate.templateContent) || false
        } catch (exeption) {
            console.error(exeption)
            // TODO dispatch error message notification : Error loading template try again later.
        }
        return templateContent
    }

    /**
     * This function will provide the recipient list by the object created the template editor
     * @param {*} templateContent
     * @param {*} moduleOptions
     */
    getNewTemplateRecipients(templateContent, moduleOptions) {
        const { options: { EmailTemplateRelations, moduleKey } } = this.props
        
        let templateRecipients = !underscore.isEmpty(templateContent) && templateContent.recipients || false
        templateRecipients = !underscore.isEmpty(templateRecipients) && templateRecipients.filter((oneRec, indexRec) => {
            const isFoundInTheWhiteList = EmailTemplateRelations.recipientsWithModules.filter((whiteRec, whiteRecIndex) =>
                ((!underscore.isEmpty(whiteRec.moduleWhiteList) && whiteRec.moduleWhiteList.indexOf(moduleKey) > -1)
                && (whiteRec.value === oneRec.value))
            )

            // BEWB-730
            // special scenario to filtering the recipient, because in quickReply mode from inbox can let one recipient depending
            // on what entity ID is provided by the ticket. The template must contain all willemot kind recipients, but we have to
            // filter out after the existing enitity ID
            if (moduleOptions.quickReply && moduleOptions.startedFromModule === c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT) {
                if (moduleOptions.claimId) {
                    return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value
                } else if (moduleOptions.contractId) {
                    return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value
                } else if (moduleOptions.tarificationId) {
                    return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value
                } else { // just client ID what we have, we can let the simple willemot recipient, hut this must be asked
                    return oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemot.value ||
                        oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value
                }
            }

            return !underscore.isEmpty(isFoundInTheWhiteList) && isFoundInTheWhiteList.length > 0 || false
        }) || false

        return templateRecipients
    }

    /**
     * This fuction make selected the default recipient
     * @param {array} templateRecipients
     * @param {array} moduleOptions
     */
    makeSelectedDefaultRecipient(templateRecipients, moduleOptions) {
        const {fields, options: {EmailTemplateRelations}} = this.props
        let defaultRec = false
         // default to select
        if (templateRecipients) {
            templateRecipients.forEach((oneRec) => {

                // BEWB-730
                // special scenario to marking the recipient as default, because in quickReply mode from inbox can let one recipient depending
                // on what entity ID is provided by the ticket and that must be dafault selected.
                if (moduleOptions.quickReply && moduleOptions.startedFromModule === c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT) {
                    if (moduleOptions.claimId && oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value) {
                        oneRec.default = true
                    } else if (moduleOptions.contractId) {
                        oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value
                        oneRec.default = true
                    } else if (moduleOptions.tarificationId) {
                        oneRec.value === EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value
                        oneRec.default = true
                    } else { // just client ID what we have, we can let the simple willemot recipient as default
                        oneRec.default = true
                    }
                }

                if( oneRec.default ) {
                    // if default we have to return to use for filling in the form with related values
                    defaultRec = JSON.parse(JSON.stringify(oneRec))
                    // if the same what was before we dont do the change, preventing unnecessary component update
                    if(  fields.recipientField.value !== oneRec.value ) {
                        this.updateFormValue({value: oneRec.value}, fields.recipientField)
                    }
                }
            })
        }
        return defaultRec
    }

    /**
     * This function will provide all email addresses available for "TO" recipient of email.
     * @param {*} recipientValue
     * @param {*} templateRecipients
     */
    getNewEmailToOptions(recipientValue, templateRecipients, templateContent, willemotInCc = false) {
        const fechedEmailAddresses = this.fetchRecipientEmails(recipientValue, templateRecipients, templateContent, willemotInCc)
        let emailToOptions = []

        // underscore can check the empty array/object also as empty,
        if (!underscore.isEmpty(fechedEmailAddresses)) {
            emailToOptions = fechedEmailAddresses.map((recEmail) => {
                return {
                    value: recEmail.value, label: (recEmail.label || "") + " <" + recEmail.value + ">",
                    name: recEmail.label, isPermanentSelected: !!recEmail.isPermanentSelected,
                    isRecent: !!recEmail.isRecent, isCC: !!recEmail.isCC
                }
            })
        }

        return emailToOptions
    }

    /**
     * This function will return with all of the email addresses for "FROM" list of email.
     */
    getNewEmailFromOptions() {
        const userId = nesProp.get(this.props, "options.userId")
        const moduleOptions = nesProp.get(this.state, "moduleOptions")
        let brNr = moduleOptions.brokerNumber
        const brokers = nesProp.get(this.props, "options.office.brokers")
        let emailFromOptions = []
        // check if module is office this case from email address comes from a template selected in dswizard step one snd stored under broker email address 
        const uploadedOnModuleOffice = moduleOptions && moduleOptions.dsPackage && moduleOptions.dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE

        if(uploadedOnModuleOffice) {
            emailFromOptions.push({
                value: moduleOptions.dsPackage.brokerEmailAddress,
                label: moduleOptions.dsPackage.brokerEmailAddress
            })
        } else 
        if ( !underscore.isEmpty(brokers) ) {
            Object.keys(brokers).forEach((brokerKey)=>{

                // filter only the current broker related emails
                let brokerNumber = nesProp.get(brokers, brokerKey+".brokerNumber")

                if (brNr && brokerNumber && brNr.localeCompare(brokerNumber) !== 0) {
                    return
                }

                // collecting email addresses
                let emails = nesProp.get(brokers, brokerKey+".main.emails")
                let name = nesProp.get(brokers, brokerKey+".main.name") || _("unknownName")
                emailFromOptions = !underscore.isEmpty(emails) && emailFromOptions.concat(
                    emails.map((oneEmail) => ({
                        value: oneEmail,
                        label: oneEmail
                        //name + " <" + oneEmail + ">"
                    }))
                ) || emailFromOptions

                // find the email address of the logged user by ID
                let staffList = nesProp.get(brokers, brokerKey+".staff")
                if (staffList && staffList.length > 0) {
                    staffList.forEach((oneStaff)=>{
                        if (oneStaff.userId == userId) {
                            emailFromOptions.push({
                                value: oneStaff.email,
                                label: oneStaff.email
                                //oneStaff.firstName+" "+oneStaff.lastName+" <" +  oneStaff.email + ">"
                            })
                        }
                    })
                }
            })
        }


        // BEWB-322 this part is removed as asked in task by silke and brecht
        // This part of the mail address finding is not sure it's needed.
        // const accountManagers = nesProp.get(this.props, "options.office.accountManagers")
        // if ( !underscore.isEmpty(accountManagers) && accountManagers.length > 0) {
        //     emailFromOptions = emailFromOptions.concat( accountManagers.filter((oneManager)=>{
        //         return !underscore.isEmpty( oneManager.email )
        //     }).map((oneManager)=>({
        //         value: oneManager.email,
        //         label: oneManager.email
        //         //(oneManager.name || oneManager.Name || _("unknownName")) + " <" + oneManager.email + ">"
        //     })))
        // }



        // filtering duplicated email addresses
        let result = [], helperAlreadyInserteds = []
        if ( emailFromOptions && emailFromOptions.length > 0 ) {
            emailFromOptions.forEach((val, index)=>{
                if (helperAlreadyInserteds.indexOf(val.value) === -1) {
                    result.push({ value: val.value, label: val.label })
                    helperAlreadyInserteds.push(val.value)
                }
            })
        }

        return result
    }

    /**
     * This function will return the "name" attached to an email address.
     * @param {string} value
     * @param {array} emailFromOptions
     */
    getNewEmailFromName(value, emailFromOptions) {
        let selectedEmailFromName = emailFromOptions
        .filter((elem)=>(elem.value === value))
        selectedEmailFromName = selectedEmailFromName.length > 0 ? selectedEmailFromName[0].label : ""

        return selectedEmailFromName
    }

    /**
     * Return the language list for language select input.
     */
    getNewLangOptions() {
        return [
            {value: "nl", label: _('nl')},
            {value: "fr", label: _('fr')},
        ]
    }

    /**
     * This function returns a set of signature for signature select input.
     */
    getNewSignatureOptions() {
        const {signatures} = this.props.options
        return signatures && signatures.map((val)=>{
            return {value: val._id, label: val.name}
        }) || []
    }

    /**
     * This function will provide the variable list from template content by selected module and recipient
     */
    getNewVariables(templateContent, recipient) {
        const {moduleKey, EmailTemplateRelations} = this.props.options
        return nesProp.get(templateContent, "content." + recipient + ".independents.variables") || []
    }

    /**
     * This function will provide the indexType of template after the given recipient from the
     * Given templateContent object
     * @param {object} templateContent
     * @param {string} recipient
     */
    getNewTemplateIndexType(templateContent, recipient) {
        const {moduleKey, EmailTemplateRelations} = this.props.options
        return nesProp.get(templateContent, "content." + recipient + ".independents.indextype") || {}
    }

    /**
     * This will generate email html content
     */
    getNewEmailContentHtml() {
        const {fields: {emailBodyField}} = this.props
        //compose and return result html
        return (emailBodyField &&  this.parseAndReplaceVariables(emailBodyField.value, this.state.activeLanguageTabValue) || "")
    }

    /**
     * This will generate email html content
     */
    getNewEmailSignatureHtml() {
        const {fields: {signatureField}} = this.props
        const {signatures} = this.props.options
        // fetch signature data
        let signatureId = signatureField  && signatureField.value
        let slectedSignatureDoc = signatures && signatures.filter(
            (item) => item._id == signatureId
        )
        const signatureHtml = nesProp.get(slectedSignatureDoc, "0.content") || ''

        //compose and return result html
        return signatureHtml
    }

    /**
     * This function will give you an array, contains all of the drv property values of all img tags
     * from of the selected signature html
     */
    getSelectedSignatureUsedImagesUrlList() {
        const {fields: {signatureField}} = this.props
        const {signatures} = this.props.options
        // fetch signature data
        let signatureId = signatureField  && signatureField.value
        let slectedSignatureDoc = signatures && signatures.filter(
            (item) => item._id == signatureId
        )
        const signatureHtml = nesProp.get(slectedSignatureDoc, "0.content") || ''
        let listOfImageUrls = fetchSrcValuesFromHtml(signatureHtml)

        return listOfImageUrls
    }

    /**
     * This function make a quick validation, and return with result.
     */
    forceValidate() {
        const fieldsForValidate = {}
        // const {emailServerConfigError} = this.state
        Object.keys(this.props.fields).forEach((key)=>{
            fieldsForValidate[key] = this.props.fields[key].value
        })

        // let errors = null
        // errors = validate(fieldsForValidate)
        // if(emailServerConfigError && emailServerConfigError.length > 0){
        //     errors.emailFromField = emailServerConfigError
        // }
        // return errors

        // v8
        // attach more complex, extra validation conditions for the form validation
        // the version 4.2.0 of redux-form, not sure if have an official way to validate
        // the form by extra corelation of values but the field values, maybe if you are using
        // <Field ... tags instead of third party type of fields like tinyMCE, can be added some
        // validate = {something} argument
        let extraConditions = {
            multiLanguage: this.props.options.multiLanguage,
            stakeholders: this.state.moduleOptions.stakeholders,
            nlBody: this.state.nlLanguageTabBodyValue,
            frBody: this.state.frLanguageTabBodyValue
        }

        return validate(fieldsForValidate, extraConditions)
    }

    /**
     * This function return with a boolean value when the redux-form fields contains error
     */
    hasErrors() {
        let errors = this.forceValidate()
        return (errors && Object.keys(errors).length > 0) ? errors : false
    }

    /**
     * Triggered before update the module.
     * @param {object} nextProps
     * @param {object} nextState
     */
    componentWillUpdate(nextProps, nextState) {
        const {fields: {emailTemplateField, recipientField, emailLanguageField, emailFromField, emailToSelectField,
            emailToSelectFieldCC, subjectField, emailBodyField, signatureField},
            options: {templates, lang, EmailTemplateRelations, moduleKey}, isPhone, goBack, office} = this.props

        // don't let to continue update because of the new state values needed, what will be in the state in
        // te next update
        let mergeResult = this.initAndMixPropsToModuleOptionsState(nextProps.options.moduleOptions, nextState.moduleOptions)

        if (mergeResult.wasAChange) {
            this.initializeSignatures(mergeResult.moduleOptions.brokerNumber)
            this.setState({moduleOptions: mergeResult.moduleOptions})
            return
        }

        // check if we have to set state by watching the props
        const langOptions = this.getNewLangOptions() // sync, independent
        if ( JSON.stringify(langOptions) !== JSON.stringify(nextState.langOptions) ) {
            return this.setState({langOptions})
        }

        // we have to initialize the content of message body here separately because it is not a regular form field
        // REMOVED BECAUSE IT RESET THE CURSOR IN EDITOR WHEN WE DO A COMPLETE CONTENT SWITCH
        /* if( nextProps.fields.emailBodyField.value !== this.props.fields.emailBodyField.value ) {
            this.initializeBodyEditor(
                nextProps.fields.emailBodyField.value,
                nextProps.fields.recipientField.value,
                nextProps.fields.emailLanguageField.value
            )
        } */

        // check if we have to set state by watching the props
        const signatureOptions = this.getNewSignatureOptions()
        if ( JSON.stringify(signatureOptions) !==  JSON.stringify(nextState.signatureOptions) ) {
            return this.setState({signatureOptions})
        }

        // process email details for providing
        let rec = nesProp.get(nextProps.fields, "recipientField.value") || ''
        let selectedLangVal = nesProp.get(nextProps.fields, "emailLanguageField.value") || ''
        let selectedTemplateVal = nesProp.get(nextProps.fields, "emailTemplateField.value") || ''
        let selectedTemplate = this.getNewSelectedTemplate(selectedTemplateVal)
        let templateContent = this.getNewTemplateContent(selectedTemplate)
        let templateRecipients = this.getNewTemplateRecipients(templateContent, nextState.moduleOptions)
        let recName = templateRecipients && templateRecipients.filter((item)=>(item.value == rec))
            recName = recName && recName[0] && recName[0].value
        let selectedTemplateIndexType = this.getNewTemplateIndexType(templateContent, rec)
        let abbreviation = nesProp.get(selectedTemplate, "abbreviation."+selectedLangVal) || ''
        let templateTitle = nesProp.get(selectedTemplate, "title."+selectedLangVal) || ''
        let toSelect = nesProp.get(nextProps.fields, "emailToSelectField.value") || ''
        let toSelectCC = nesProp.get(nextProps.fields, "emailToSelectFieldCC.value") || ''
        let toSelectEmailsChained = toSelect && Array.isArray(toSelect) && toSelect.length > 0 ?
            toSelect/* .filter((oneSelectedAddress)=>{return !oneSelectedAddress.isCC}) */.map((item)=>(item.value)).join(';') : ''
        let ccSelectEmailsChained = toSelectCC && Array.isArray(toSelectCC) && toSelectCC.length > 0 ?
            toSelectCC/* .filter((oneSelectedAddress)=>{return !!oneSelectedAddress.isCC}) */.map((item)=>(item.value)).join(';') : ''
        let signatureId = nesProp.get(nextProps.fields, "signatureField.value")
        let fromName = this.state.selectedEmailFromName && this.state.selectedEmailFromName.split('<')
            fromName = fromName && Array.isArray(fromName) && fromName.slice(0, fromName.length - 1)
            fromName = fromName && Array.isArray(fromName) && fromName.join('')
            fromName = fromName && fromName.trim()

        // we have implemented to attach file like a link but finally we only use the hardly attached files
        let allAttachmentTogether = [].concat(nextState.attachments || []).concat(nextState.hardAttachments || [])
        const moduleOptions = nesProp.get(this.state, "moduleOptions")

        // decide the module where was sent the email to able reassign the module in the future PDF uploads
        // EmailTemplateModules.clientsProfile
        let uploadedOnModule = c.DS_MODULE_CLIENT_PROFILE

        if (moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value) {
            uploadedOnModule = c.DS_MODULE_CLIENT_CONTRACT
        }
        if (moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value ||
            moduleKey == EmailTemplateRelations.EmailTemplateModules.claims.value) {
            uploadedOnModule = c.DS_MODULE_CLIENT_CLAIMS
        }
        if (moduleKey == EmailTemplateRelations.EmailTemplateModules.clientTarificationDetails.value) {
            uploadedOnModule = c.DS_MODULE_CLIENT_TARIFICATION
        }


        //+++ TODO set value for uploadedOnModule for inboxReplyToWillemot +++
        // WHERE TO UPLOAD THE COPY OF THE EMAIL ON ORACELE - HERE TO MODIFY IF THE CLIENT PROFILE MODULE IS NOT GOOD
        if (moduleKey == EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value) {
            // TODO - here to give a different option, where to upload the copy of the email,
            // by default we use the client profile module
            uploadedOnModule = c.DS_MODULE_CLIENT_PROFILE
        }

        if(moduleKey === 'mifid' && moduleOptions && moduleOptions.dsPackage ) {
            uploadedOnModule = moduleOptions.dsPackage.uploadedOnModule
        }

        //--- END OF TODO ---



        // the rest of options never should be arrived here like:
        // EmailTemplateModules.clientAccountApproval, EmailTemplateModules.mifid
        // Because this are used on server-side email sending.

        // compose the result object for the callback, this means the final hole data for email to send
        const finalEmail = {
            brokerNumber: nesProp.get(moduleOptions, "brokerNumber"),
            fromName: fromName || "",
            senderEmail: emailFromField.value || "",
            cleanSenderEmail: emailFromField.value || "",
            to: toSelectEmailsChained,
            cc: ccSelectEmailsChained,
            subject: subjectField.value,
            message: this.getNewEmailContentHtml(),

            // +++ the followings are used for serial multi language sending
            nlSubject: nextState.nlLanguageTabSubjectValue,
            nlMessage: nextState.nlLanguageTabBodyValue,
            frSubject: nextState.frLanguageTabSubjectValue,
            frMessage: nextState.frLanguageTabBodyValue,
            // --- end of multi language part ---

            signatureHtml: this.getNewEmailSignatureHtml(),
            disclaimerHtml: this.props.haveDisclaimer ? _("disclaimerText", nextState.activeLanguageTabValue || "nl") : "",
            signatureImageUrls: this.getSelectedSignatureUsedImagesUrlList(),
            // attachments: nextState.attachments || [],
            attachments: [],
            // hardAttachments: nextState.hardAttachments || [],
            hardAttachments: allAttachmentTogether || [],
            recipient: recName,
            templateId: selectedTemplate._id,
            templateIndexType: nesProp.get(selectedTemplateIndexType, "type") || '',
            templateLowValue: nesProp.get(selectedTemplateIndexType, "lowValue") || '',
            templateTitle: templateTitle,
            templateAbbr: abbreviation,
            clientId: this.state.moduleOptions.clientId,
            contractId: this.state.moduleOptions.contractId,
            tarificationId: this.state.moduleOptions.tarificationId,
            claimId: this.state.moduleOptions.claimId,
            signatureId: signatureId,

            // test line the next 4 remove
            moduleKey: moduleKey,
            variables: EmailTemplateRelations.EmailTemplateVariables,
            moduleOptions: this.state.moduleOptions,
            moduleOptionsNotUpdated: this.props.options.moduleOptions,
            uploadedOnModule: uploadedOnModule,
            emailType: this.state.moduleOptions.quickReply ? EMAIL_TYPE_QUICK_REPLY : EMAIL_TYPE_DEFAULT,
            ticketId: this.state.moduleOptions.ticketId || ''
        }

        // if there are invalid field or precache in progress
        const hasErrorsValue = this.hasErrors() || this.state.precacheInProgress
        this.props.dataCallbackDisableSend(hasErrorsValue)

        // calling the data provider for outher module if we have changes to prevent the refresh if obsolote
        if (JSON.stringify(finalEmail) !==  JSON.stringify(nextState.finalEmail)) {
            this.props.dataCallback(finalEmail)
            return this.setState({finalEmail})
        }

        // control multi language subject
        if (nextProps.fields.subjectField.value !== this.props.fields.subjectField.value) {
            // update multi language fields as well
            if (this.props.options.multiLanguage) {
                if (nextState.activeLanguageTabValue === 'fr') {
                    this.setState({frLanguageTabSubjectValue: nextProps.fields.subjectField.value})
                } else {
                    this.setState({nlLanguageTabSubjectValue: nextProps.fields.subjectField.value})
                }
            }
        }

        // control multi language body
        if (nextProps.fields.emailBodyField.value !== this.props.fields.emailBodyField.value) {
            // update multi language fields as well
            if (this.props.options.multiLanguage) {
                if (nextState.activeLanguageTabValue === 'fr') {
                    this.setState({frLanguageTabBodyValue: nextProps.fields.emailBodyField.value})
                } else {
                    this.setState({nlLanguageTabBodyValue: nextProps.fields.emailBodyField.value})
                }

            }
        }
    }

    /**
     * This function will collect the available variable values for the body and subject
    */
    fetchEmailModuleVariableRealValues(selectedTemplate, language) {
        const {moduleKey, EmailTemplateRelations} = this.props.options
        const {moduleOptions} = this.state

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.contractNumber.fetchValue",
            nesProp.get(moduleOptions, "contractNumber")) || ''
	    nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientNumber.fetchValue",
            nesProp.get(moduleOptions, "clientNumber")) || ''

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientName.fetchValue",
            nesProp.get(moduleOptions, "clientName")) || ''

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientName.doTranslate", false)
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.signerName.doTranslate", false)
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.privateLinkPlaceholder.doTranslate", false)
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.privateSigningUrl.doTranslate", false)
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.F2FSigningUrl.doTranslate", false)

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.claimsNumber.fetchValue",
            nesProp.get(moduleOptions, "claimsNumber")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.templateTitleAbbr.fetchValue",
            nesProp.get(selectedTemplate, "abbreviation."+language)) || ''

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.officeContract.fetchValue",
            nesProp.get(moduleOptions, "officeContract")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.brokerNumber.fetchValue",
            nesProp.get(moduleOptions, "brokerNumber")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.commercialOfficeName.fetchValue",
            nesProp.get(moduleOptions, "commercialOfficeName")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.company.fetchValue",
            nesProp.get(moduleOptions, "company")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.contractBranch.fetchValue",
            nesProp.get(moduleOptions, "contractBranche")) || ''

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.carBrand.fetchValue", nesProp.get(moduleOptions, "claimDetail.carBrand")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.chassisNumber.fetchValue", nesProp.get(moduleOptions, "claimDetail.chassisNumber")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.licensePlate.fetchValue", nesProp.get(moduleOptions, "claimDetail.licensePlate")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.insuredValue.fetchValue", nesProp.get(moduleOptions, "claimDetail.insuredValue")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanName.fetchValue", nesProp.get(moduleOptions, "claimDetail.repName")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanFirstName.fetchValue", nesProp.get(moduleOptions, "claimDetail.repFirstName")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanStreet.fetchValue", nesProp.get(moduleOptions, "claimDetail.repStreet")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanStreetNumber.fetchValue", nesProp.get(moduleOptions, "claimDetail.repNumber")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanBox.fetchValue", nesProp.get(moduleOptions, "claimDetail.repBox")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanPostalCode.fetchValue", nesProp.get(moduleOptions, "claimDetail.repPostalCode")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanTown.fetchValue", nesProp.get(moduleOptions, "claimDetail.repTown")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.repairmanPhoneNumber.fetchValue", nesProp.get(moduleOptions, "claimDetail.repPhone")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertName.fetchValue", nesProp.get(moduleOptions, "claimDetail.expName")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertFirstName.fetchValue", nesProp.get(moduleOptions, "claimDetail.expFirstName")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertStreet.fetchValue", nesProp.get(moduleOptions, "claimDetail.expStreet")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertStreetNumber.fetchValue", nesProp.get(moduleOptions, "claimDetail.expNumber")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertBox.fetchValue", nesProp.get(moduleOptions, "claimDetail.expBox")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertPostalCode.fetchValue", nesProp.get(moduleOptions, "claimDetail.expPostalCode")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertTown.fetchValue", nesProp.get(moduleOptions, "claimDetail.expTown")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertPhoneNumber.fetchValue", nesProp.get(moduleOptions, "claimDetail.expPhone")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.expertMail.fetchValue", nesProp.get(moduleOptions, "claimDetail.expEmail")) || ''

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.qualification.fetchValue", nesProp.get(moduleOptions, "claim.main.qualification") ||
            nesProp.get(moduleOptions, "claim.claimMain.qualification")) || ''

        let claimDate = nesProp.get(moduleOptions, "claim.main.claimDate") || nesProp.get(moduleOptions, "claim.claimMain.claimDate") || ''
        let claimDateMoment   = moment(claimDate, 'YYYY-MM-DD', true)
        let claimDateIsValid = claimDateMoment.isValid()

        if (claimDateIsValid) {
            claimDate = claimDateMoment.format("DD-MM-YYYY")
        }

        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.claimDate.fetchValue", claimDate)
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientStreet.fetchValue", nesProp.get(moduleOptions, "clientData.mainAddress.street")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientStreetNumber.fetchValue", nesProp.get(moduleOptions, "clientData.mainAddress.number")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientBusNumber.fetchValue", nesProp.get(moduleOptions, "clientData.mainAddress.extension")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientPostalCode.fetchValue", nesProp.get(moduleOptions, "clientData.mainAddress.postalCode")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientTown.fetchValue", nesProp.get(moduleOptions, "clientData.mainAddress.locality")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.companyReference.fetchValue", nesProp.get(moduleOptions, "claimDetail.companyReference")) || ''

        // tarification variables
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.tarificationNumber.fetchValue", nesProp.get(moduleOptions, "tarificationDetail.tarificationNumber")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.maingroupDescription.fetchValue", nesProp.get(moduleOptions, "tarificationDetail.maingroupDescription")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.subgroupDescription.fetchValue", nesProp.get(moduleOptions, "tarificationDetail.subgroupDescription")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.descriptionRisico.fetchValue", nesProp.get(moduleOptions, "tarificationDetail.descriptionRisico")) || ''
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.brokerName.fetchValue",
            nesProp.get(moduleOptions, "tarificationDetail.brokerName") || nesProp.get(moduleOptions, "dsPackage.brokerName"))

        // v8
        // mifid wizard variables
        nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.F2FSigningUrl.fetchValue", nesProp.get(moduleOptions, "dsPackage.F2FSigningUrl")) || '...'

        // if the flag "usePlaceholdersForClientVariables" is true, must use placeholders, not real values, because of serial sending of the same email
        // for the clients, but before the sending must be replaced individually by the private custom values of the signer
        if (moduleOptions.usePlaceholdersForClientVariables) {
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.F2FSigningUrl.fetchValue", DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.F2FSigningUrl.doTranslate", true)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.privateSigningUrl.fetchValue", DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.privateSigningUrl.doTranslate", true)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.privateLinkPlaceholder.fetchValue", DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.privateLinkPlaceholder.doTranslate", true)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientName.fetchValue", DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.clientName.doTranslate", true)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.signerName.fetchValue", DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY)
            nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.signerName.doTranslate", true)
        }

        // nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.disclaimerPlaceholder.fetchValue", DISCLAIMER_PLACEHOLDER_TRANS_KEY)
        // nesProp.set(EmailTemplateRelations, "EmailTemplateVariables.disclaimerPlaceholder.doTranslate", true)
    }

    /**
     * This function will return with the default language code for initialize the modal language
     * @param {*} clientLanguage
     * @param {*} forceSelectedToEmail
     * @returns
     */
    fetchRecipientLanguage(clientLanguage = '', forceSelectedToEmail = null) {
        const {moduleKey, EmailTemplateRelations, contractManagerLanguage,
            claimsManagersDetails, lang} = this.props.options
        const {fields: {emailToSelectField, recipientField}} = this.props

        let claimsManagerLanguage = false

        // language of the client or the user
        let resultLang = clientLanguage || lang

        // find selected recipient language if exists, the first recipient matter.
        let selectedToAddress = forceSelectedToEmail || nesProp.get(emailToSelectField, 'value.0.value')
        let haveClaimsManagerEmail = claimsManagersDetails && Array.isArray(claimsManagersDetails) && claimsManagersDetails.length > 0
        if ( haveClaimsManagerEmail && selectedToAddress ) {
            claimsManagersDetails.forEach((claimsManagerElem)=>{
                if( claimsManagerElem.email && claimsManagerElem.email.localeCompare( selectedToAddress ) === 0 ) {
                    claimsManagerLanguage = claimsManagerElem.lang
                }
            })
        }

        // if there are no moduleKey passed to the email sender modal the we just use the current user language
        if ( !moduleKey) {
            return resultLang
        }

        // decide the initial language after module
        switch( moduleKey ) {
            case EmailTemplateRelations.EmailTemplateModules.clientsProfile.value: {
                resultLang = clientLanguage || lang
                break
            }
            case EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value: {
                resultLang = clientLanguage || contractManagerLanguage || lang
                break
            }
            case EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value: {
                resultLang = clientLanguage || claimsManagerLanguage || lang
                break
            }
            case EmailTemplateRelations.EmailTemplateModules.claims.value: {
                // there are no client in this case
                resultLang = claimsManagerLanguage || lang
                break
            }
        }

        // second level check: decide the initial language after recipient if selected
        let selectedRecipient = recipientField && recipientField.value
        switch( selectedRecipient ) {
            case EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value: {
                resultLang = !underscore.isEmpty(contractManagerLanguage) && contractManagerLanguage || lang
                break
            }
            case EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value: {
                resultLang = !underscore.isEmpty(claimsManagerLanguage) && claimsManagerLanguage || lang
                break
            }
            case EmailTemplateRelations.EmailTemplateRecipients.client.value: {
                resultLang = clientLanguage || lang
                break
            }
            default: {
                 // if the email from the willemot recipient
                let forceEmailLang = this.getRecipientWillemotEmailsLangByEmail(forceSelectedToEmail)
                resultLang = forceEmailLang || resultLang || lang
            }
        }

        return resultLang
    }

    /**
     * This function will parse and replace the variable values if exists. Return with the new string.
     * @param {String} body - string for parse an replace by existing variables
     * @param {String} language - when the placeholder is a translation key to translate
     */
    parseAndReplaceVariables(body, language = null) {
        const {EmailTemplateRelations} = this.props.options
        const varKeys = Object.keys(EmailTemplateRelations.EmailTemplateVariables)

        if (!underscore.isEmpty(varKeys) && varKeys.length > 0 && body) {
            let searchExp = '', replaceExp = ''
            body = String( body )

            varKeys.forEach((varKeyValue)=>{
                searchExp = nesProp.get(EmailTemplateRelations,"EmailTemplateVariables."+varKeyValue+".value") || "unknownvar"
                replaceExp = nesProp.get(EmailTemplateRelations,"EmailTemplateVariables."+varKeyValue+".fetchValue") || ""

                // only for multi-language variable placeholders
                if (nesProp.get(EmailTemplateRelations,"EmailTemplateVariables."+varKeyValue+".doTranslate")) {
                    replaceExp = _(replaceExp, language ? language : null)
                }

                body = body.replace(new RegExp("\{\{"+searchExp+"\}\}", 'g'), replaceExp)
            })
        }

        return body
    }

    /**
     * This function provide the apicall result and callback call for the tiny mce editor,
     * trough a redux action
     * @param {*} blobInfo
     * @param {*} success
     * @param {*} failure
     */
    imagesUploadHandler(blobInfo, success, failure) {
       const {dispatch} = this.props
       return dispatch(localUploadHandler(blobInfo, success, failure))
    }

    /**
     * This function will initialize the text editor for email composer
     */
    setupTinyMCE() {
        let returnEditorContext = null

        // window.tinymce.execCommand('mceAddEditor',true, "tinymce")
        window.tinymce.init({
            /*
            selector: '#tinymce', height: 500, skin_url: `skins/lightgray`, menubar: false,
            statusbar: false, toolbar: 'bold italic underline undo redo', plugins: ['paste', 'link', 'autoresize'],
            */
            file_browser_callback_types: 'image',
            // when we need tu uploade images into email only todo uncomment the next line
            //images_upload_handler: (blobInfo, success, failure) => (this.imagesUploadHandler(blobInfo, success, failure)),
            //images_upload_url: 'uploads/localUploads/',
            selector: '#tinymce', min_height: 365, menubar: false,
            mode : "readonly",
            draggable_modal: true,
            // [Jancsi] - these are not required anymore for version 5.3+ of tinyMCE, it is enough to specify the teme
            // theme_url: window.location.protocol+'//'+(window.location.href.split("/")[2] + '/themes/silver/theme.js').replace("\/\/", "\/"),
            // skin_url:  window.location.protocol+'//'+(window.location.href.split("/")[2] + '/skins/lightgray/').replace("\/\/", "\/"),

            //theme : "modern",
		    theme : "silver",
            statusbar: false,
            //toolbar: 'bold italic underline | undo redo | link | code', plugins: ['paste', 'link', 'autoresize'],
            toolbar1 : "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | formatselect fontselect fontsizeselect",
            toolbar2 : "paste pastetext searchreplace | bullist numlist | outdent indent | undo redo | link unlink anchor image code",
            toolbar3 : "forecolor backcolor | table | hr removeformat visualchars | subscript superscript | charmap preview | fullscreen",

            // [Jancsi] these are not required anymore for version 5.3+ of tinyMCE, as plugins are imported at the beginning of the file
            // external_plugins: {
            //     'textcolor': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/textcolor/plugin.js').replace("\/\/", "\/"),
            //     'link': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/link/plugin.js').replace("\/\/", "\/"),
            //     'image': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/image/plugin.js').replace("\/\/", "\/"),
            //     'code': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/code/plugin.js').replace("\/\/", "\/"),
            //     'searchreplace': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/searchreplace/plugin.js').replace("\/\/", "\/"),
            //     'paste': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/paste/plugin.js').replace("\/\/", "\/"),
            //     'visualchars': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/visualchars/plugin.js').replace("\/\/", "\/"),
            //     'charmap': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/charmap/plugin.js').replace("\/\/", "\/"),
            //     'table': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/table/plugin.js').replace("\/\/", "\/"),
            //     'fullscreen': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/fullscreen/plugin.js').replace("\/\/", "\/"),
            //     'preview': window.location.protocol+'//'+(window.location.href.split("/")[2] + '/plugins/preview/plugin.js').replace("\/\/", "\/"),
            // },
            plugins : ["textcolor link image code searchreplace paste visualchars charmap table fullscreen preview"],
            force_br_newlines : false,
            force_p_newlines : false,
            forced_root_block : '',
            relative_urls : false,
            remove_script_host : false,
            allow_script_urls: true,
            convert_urls : true,

            setup: (editor) => {
                returnEditorContext = editor
                editor.on('init', function() {
                    this.execCommand("fontName", false, "Arial");
                    this.execCommand("fontSize", false, "11pt");
                    this.execCommand("foreColor", false, 'rgba(0,0,0,1)');
                });
                this.setState({theBodyEditor: editor})
            },
            // protect: [
            //     /\{\{Link\}\}/g,
            // ]
            noneditable_class: 'mceNonEditable',
            noneditable_regexp: /\{\{Link\}\}/g
        })

        return returnEditorContext
    }

    /**
     * This function will force a font style for the first html tag
     * @param {string} html
     */
    forceFontStyleForContainerHtmlTag (html) {
        let tagHead = '<div class="userBasicStyle" style="min-height:12px; color: black;font-size: 12pt; font-weight: 400; font-family: Arial,-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,\'Helvetica Neue\',\'times new roman\',sans-serif;">'
        let tagEnd = ' </div>'

        if (!html) {
            return tagHead + html + tagEnd
        }

        if ((html.indexOf("userBasicStyleAuto") == -1) && (html.indexOf("templateBasicStyleAuto") == -1)) {
            return tagHead + html + tagEnd
        }

        return html
    }

    /**
     * This function will initialize the body editor when you call it and replace the body value instantly
     * @param {*} newValue - new body html value for email
     * @param {*} recipient - the current recipient value, if empty then reset the editor
     * @param {*} language - the current language value, if empty then reset the editor
     */
    initializeBodyEditor(newValue, recipient, language) {
        let {theBodyEditor, moduleOptions} = this.state
        const bodyField = nesProp.get(this.props, "fields.emailBodyField")

        // if the middlewear is loaded. Preventing errors
        if( window.tinymce && theBodyEditor) {
            // we can fill the editor if we have options to decide witch message template we needed.
            if (recipient && language) {
                let body = !underscore.isEmpty(newValue) && String(newValue) || ''
                body = this.parseAndReplaceVariables(body, language) || ''
                let bodyFontStyled = this.forceFontStyleForContainerHtmlTag(body)

                try {
                    // theBodyEditor && theBodyEditor.execCommand('mceSetContent', body, {format: 'raw', set: true, content: body})
                    theBodyEditor.setContent(bodyFontStyled , {format: 'raw'})
                } catch(exc) {
                    // TODO error handling. But not fo user.
                }
            } else {
                try {
                    let bodyFontStyled = this.forceFontStyleForContainerHtmlTag('')
                    // theBodyEditor && theBodyEditor.execCommand('mceSetContent', '', {format: 'raw', set: true, content: ''})
                    theBodyEditor.setContent(bodyFontStyled , {format: 'raw'})
                } catch(exc) {
                    // error handling
                }
            }

            // we have to update the form value on blur
            theBodyEditor.on('blur', (e)=>{
                let content = theBodyEditor.getContent()
                this.updateFormValue({value: content}, bodyField)
            })

            theBodyEditor.on('change', (e)=>{
                let content = theBodyEditor.getContent()
                this.updateFormValue({value: content}, bodyField)
            })

            // this for the correct timed validation, because this is not a regular reduxForm field.
            theBodyEditor.on('click', (e)=>{
                let content = theBodyEditor.getContent()
                this.updateFormValue({value: content, touched: true}, bodyField)
            })

            /* theBodyEditor.on('focus', (e)=>{
                this.updateFormValue({value: theBodyEditor.getContent(), touched: true}, bodyField)
            }) */

            // theBodyEditor.on('change', (e)=>{
            //     if (moduleOptions.private LinkPlaceholder) {
            //         let content = theBodyEditor.getContent()
            //         if (!content.includes(c.DSWIZARD_ PRIVATE_LINK_PLACEHOLDER)) {
            //             console.log("Cannot to remove link from content!")
            //         } else {
            //             theBodyEditor.setContent(content , {format: 'raw'})
            //         }
            //     }
            //     //actualCaretPositionBookmark = theBodyEditor.selection.getBookmark(2, true)
            // })

            // var iframe = theBodyEditor.getDoc().getElementById(theBodyEditor.id);
            // iframe.addEventListener('keypress', function(event) {
            //     console.log('Key pressed!', event);
            //     console.log("onKeyPress fired")
            //     if (moduleOptions.private LinkPlaceholder) {
            //         let content = theBodyEditor.getContent()
            //         if (!content.includes(c.DSWIZARD_ PRIVATE_LINK_PLACEHOLDER)) {
            //             console.log("Cannot to remove link from content!")
            //             theBodyEditor.setContent(this.lastValue , {format: 'raw'})
            //         } else {
            //             this.lastValue = content
            //         }
            //     }
            // })
        }
    }

    //lastValue = "";

    /**
     * Destruct settings for tinyMCE
     */
    unmountTinyMCE () {
        window.tinymce.execCommand('mceFocus', true, "tinymce" )
        window.tinymce.execCommand('mceRemoveEditor',true, "tinymce") //mceAddEditor
        window.tinymce.execCommand('mceRemoveControl',false, "tinymce")
    }

    /**
     * Insert a variable in to the editor
     * @param {object} e
     * @param {string} variable
     */
    onClickVariableOfEditor(e, variable, language = null) {
        const {theBodyEditor} = this.state

        let textToFill = '{{'+variable.value+'}}'
        let valueToInsert = this.parseAndReplaceVariables(textToFill, language)
        //actualCaretPositionBookmark = theBodyEditor.selection.getBookmark();
        //theBodyEditor && theBodyEditor.insertContent(valueToInsert)
        //theBodyEditor && theBodyEditor.selection.moveToBookmark(actualCaretPositionBookmark)
        //theBodyEditor && theBodyEditor.focus()
        theBodyEditor && theBodyEditor.execCommand('mceInsertContent', false, valueToInsert)
        //theBodyEditor && theBodyEditor.selection.moveToBookmark(actualCaretPositionBookmark)
        //theBodyEditor && theBodyEditor.focus()
        //theBodyEditor && theBodyEditor.selection.select(theBodyEditor && theBodyEditor.getBody(), true);
        //theBodyEditor && theBodyEditor.selection.collapse(false)
        //theBodyEditor && theBodyEditor.execCommand('mceInsertContent', false, "some text")
        //theBodyEditor.selection.setCursorLocation( theBodyEditor.selection.getNode(), 2)
        //theBodyEditor.readonly = true
    }

    onClickLanguageChangeOfEditor(e, newActiveLanguageTabValue) {
        const {fields} = this.props
        let {theBodyEditor, activeLanguageTabValue, nlLanguageTabBodyValue, frLanguageTabBodyValue,
            nlLanguageTabSubjectValue, frLanguageTabSubjectValue} = this.state

        // old content
        if (activeLanguageTabValue == 'nl') {
            nlLanguageTabSubjectValue = fields.subjectField.value
            nlLanguageTabBodyValue = theBodyEditor.getContent()
        }

        if (activeLanguageTabValue == 'fr') {
            frLanguageTabSubjectValue = fields.subjectField.value
            frLanguageTabBodyValue = theBodyEditor.getContent()
        }

        // newActiveLanguageTabValue
        if (newActiveLanguageTabValue == 'nl') {
            this.updateFormValue({value: nlLanguageTabSubjectValue, touched: true}, fields.subjectField)
            this.updateFormValue({value: nlLanguageTabBodyValue, touched: true || fields.emailBodyField.touched}, fields.emailBodyField)
            theBodyEditor.setContent(nlLanguageTabBodyValue , {format: 'raw'})
        }

        if (newActiveLanguageTabValue == 'fr') {
            this.updateFormValue({value: frLanguageTabSubjectValue, touched: true}, fields.subjectField)
            this.updateFormValue({value: frLanguageTabBodyValue, touched: true || fields.emailBodyField.touched}, fields.emailBodyField)
            theBodyEditor.setContent(frLanguageTabBodyValue , {format: 'raw'})
        }

        // put back all the stuffs
        this.setState({
            activeLanguageTabValue: newActiveLanguageTabValue,
            nlLanguageTabSubjectValue,
            nlLanguageTabBodyValue,
            frLanguageTabSubjectValue,
            frLanguageTabBodyValue
        })
    }

    /**
     * This function will initialize the editor and insert the correct content in it
     * @param {*} options
     * @param {*} emailBodyField
     */
    renderBodyEditor(options, emailBodyField) {
        const {theBodyEditor, textEditorAlreadySet} = this.state
        let variables = this.state.variables

        if( window.tinymce && theBodyEditor) {

            if( options && options.disabled ) {
                if (textEditorAlreadySet) {
                    this.setState({textEditorAlreadySet: false})
                }

                theBodyEditor.setMode("readonly")
            } else {
                theBodyEditor.setMode("design")

                if (!textEditorAlreadySet) {
                    theBodyEditor.setMode("design")
                    this.setState({textEditorAlreadySet: true})

                    theBodyEditor.focus()
                    theBodyEditor.selection.select(theBodyEditor && theBodyEditor.getBody(), true);
                    theBodyEditor.getBody().focus()
                }
            }
        }

        return (
            <div key="variableEditorMainContainerKey">
                <div className={cs(styles.formGroup)}>
                    <label className={styles.formLabel} htmlFor="emailBodyField">{_("messageContent")}*</label>
                    <div className={styles.formInput}>
                        <div className={styles.variablesContainer}>
                            {variables && variables.map(
                                (oneVar,oneVarIndex) => {
                                    return (
                                    <div key={"variableindex"+oneVarIndex}
                                        onClick={(e) => (this.onClickVariableOfEditor(e, oneVar, this.state.activeLanguageTabValue))}
                                        className={styles.variableTab}>
                                        {_("variable_"+oneVar.value)}
                                    </div>)
                                }
                            )}
                        </div>
                        <textarea id="tinymce" />
                    </div>

                </div>
            </div>
        )
    }

    /**
     * This universal email address collector function give a list of emails filtered by
     * current moduleKey and recipient list
     * @param {*} templateRecipients
     */
    fetchRecipientEmails(selectedRecipient, templateRecipients, templateContent, willemotInCc = false) {
        const {moduleKey, EmailTemplateRelations, contractManagerMail,
            contractManagerLanguage, claimsManagersDetails, claimsManagers} = this.props.options
        const {moduleOptions} = this.state

        let quickReply = nesProp.get(moduleOptions, "quickReply") || []
        let clientEmails = nesProp.get(moduleOptions, "clientEmails") || []
        let brNr = nesProp.get(moduleOptions, "brokerNumber") || ''
        let emailRecentRecipients = nesProp.get(moduleOptions, "emailRecentRecipients") || []
        let companyCancelMail = nesProp.get(moduleOptions, "companyCancelMail") || []
        let tarificationManagerMail = nesProp.get(moduleOptions.tarificationDetail, "tarificationManagerMail")
        let tarificationManagerLanguage = nesProp.get(moduleOptions.tarificationDetail, "tarificationManagerLanguage")

        let willemotProductionTranslationKey = 'recipient'+
                            EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value.charAt(0).toUpperCase() +
                            EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value.slice(1)

        let emailCompany = nesProp.get(moduleOptions, "claimDetail.emailCompany") || ""
        let expertEmail = nesProp.get(moduleOptions, "claimDetail.expEmail") || ""
        let emailCounterParty = nesProp.get(moduleOptions, "claimDetail.emailCounterParty") || ""

        // in case when we are on client profile, only the client email addresses are available
        const isClientProfileModule = (moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value)

        //const isMifidModule = (moduleKey == EmailTemplateRelations.EmailTemplateModules. mifid.value)


        let resultEmailList = [] // this array will be the final result of this function
        let recentEmailAddresses = [] // this addresses must be at the end of the list

        // add to the end of the recipient email addresses list the broker recently used email addresses if exists
        let brokerRecents = emailRecentRecipients && emailRecentRecipients.filter((oneRecent) => (oneRecent.brokerNumber === brNr)) || []

        // generating  translation key for the current recipient - requirement by Willemot
        let recipientTranslationKey = ''
        if (selectedRecipient) {
             recipientTranslationKey = 'recipient'+selectedRecipient.charAt(0).toUpperCase() + selectedRecipient.slice(1)
        }

        // format data-structure of fetched recent recipients to be digestible for the input
        brokerRecents.forEach((oneEmail) => {
            recentEmailAddresses.push({value: oneEmail.email, lang: oneEmail.lang, label: '', isRecent: true})
        })
        recentEmailAddresses.sort((a, b) => (a.count > b.count) ? -1 : 1)

        // if there are no recipients for the template then remains just the frequently used email addresses.
        let isThisTheContractModule =
            moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value

        if ( underscore.isEmpty(templateRecipients) ) {
            return resultEmailList.concat(recentEmailAddresses)
        }

        if ( !underscore.isEmpty( selectedRecipient ) ) {
            switch( selectedRecipient ) {
                case EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value: {
                    // if we have contractManagerEmail but we are on contracts only
                    // claims module not available contract
                    if (isThisTheContractModule && contractManagerMail) {
                        resultEmailList.push({
                            value: contractManagerMail,
                            lang: contractManagerLanguage,
                            // must use the translated recipient label (requirement)
                            label: _(recipientTranslationKey)
                        })
                    }
                    break
                }

                case EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value: {
                    // we use the claim addresses if we are on that module where are fetched this addresses.
                    let isThisTheClientClaimModule =
                        moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsClaimsDetail.value
                    let isThisTheClaimModule =
                        moduleKey == EmailTemplateRelations.EmailTemplateModules.claims.value
                    let actualClaimId = nesProp.get(this.state, "moduleOptions.claimId")
                    let managerDetails = []

                    // client claims module
                    if (isThisTheClientClaimModule && claimsManagersDetails && Array.isArray(claimsManagersDetails) &&
                        claimsManagersDetails.length > 0) {
                        // only the current claim manager
                        managerDetails = claimsManagersDetails
                            .filter((oneManager)=>(oneManager.claimId == actualClaimId || !actualClaimId))
                    }

                    // claims module
                    if (isThisTheClaimModule && claimsManagers && Array.isArray(claimsManagers) &&
                        claimsManagers.length > 0) {
                        managerDetails = claimsManagers
                            .filter((oneManager)=>(oneManager.claimId == actualClaimId || !actualClaimId))
                    }

                    // each module use if exists
                    if (contractManagerMail) {
                        managerDetails.push({
                            email: contractManagerMail,
                            lang: contractManagerLanguage,
                            // must use the translated recipient label (requirement)
                            name: _(recipientTranslationKey)
                        })
                    }

                    // quick filter the duplicated values
                    let filteredManagerDetails = []
                    managerDetails.forEach((oneManager) => {
                        // if we have the same email address we don't need to add again
                        let alreadyAdded = filteredManagerDetails.length > 0 &&
                            filteredManagerDetails.filter((secondManager) => {

                                let email  = nesProp.get(secondManager, "email")
                                let email2  = nesProp.get(oneManager, "email")

                                return (String(email).localeCompare(email2) === 0)
                            })

                        if(!alreadyAdded || (Array.isArray(alreadyAdded) && alreadyAdded.length == 0)) {
                            filteredManagerDetails.push({...oneManager})
                        }
                    })

                    managerDetails = filteredManagerDetails

                    let isOkClaimManagerDetail = managerDetails && Array.isArray(managerDetails) &&
                        managerDetails.length > 0

                    if (isOkClaimManagerDetail) {
                        managerDetails.forEach((claimsManagerElem) => {
                            resultEmailList.push({
                                value: claimsManagerElem.email,
                                //label: EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.label,
                                //label: claimsManagerElem.name,
                                // must use the translated recipient label (requirement)
                                label: _(recipientTranslationKey),
                                lang: claimsManagerElem.lang
                            })
                        })
                    }
                    break
                }

                case EmailTemplateRelations.EmailTemplateRecipients.thirdParties.value: {
                    // resultEmailList = []
                    break
                }

                case EmailTemplateRelations.EmailTemplateRecipients.client.value: {
                    resultEmailList = resultEmailList.concat(clientEmails)

                    // EXIT POINT (EXCEPTION IN FUNCTIONALITY):
                    // On client profile, when the recipient is client we just let only the client email addresses to select
                    // BEWB-354
                    if (isClientProfileModule) {
                        // reset the result if any of other addresses added from template or anywhere, jut use the client own addresses
                        resultEmailList = clientEmails

                        // end function avoid any other concat or manipulation
                        return resultEmailList
                    }

                    break
                }

                // v8
                case EmailTemplateRelations.EmailTemplateRecipients.digitalSignatureClient.value: {
                    // resultEmailList = resultEmailList.concat(clientEmails)

                    //if (isMifidModule) {
                        // reset the result to the stakeholder email adresses what is in the clientEmails when comming from mifid
                        resultEmailList = clientEmails

                        // end function avoid any other concat or manipulation
                        return resultEmailList
                    //}

                    break
                }

                case EmailTemplateRelations.EmailTemplateRecipients.willemot.value: {
                    if (templateContent) {
                        let recipientWillemotEmailsUsedIds = nesProp.get(templateContent, "recipientWillemotEmails")
                        resultEmailList = resultEmailList.concat(this.getRecipientWillemotEmailsByIds(recipientWillemotEmailsUsedIds))
                    }
                    break
                }

                // new v5
                case EmailTemplateRelations.EmailTemplateRecipients.company.value: {
                    let listCompanyEmails = emailCompany ? [{
                        value: emailCompany,
                        label: _(recipientTranslationKey)
                    }] : []

                    resultEmailList = resultEmailList.concat(listCompanyEmails)

                    // requirement V6 extra issues,
                    // when company recipient selected on client contract, willemot production must added in CC
                    if (isThisTheContractModule) {
                        resultEmailList.push({
                            value: contractManagerMail,
                            lang: contractManagerLanguage,
                            // must use the translated recipient label (requirement)
                            isPermanentSelected: isThisTheContractModule ? true : false,
                            isCC: true,
                            label: _(willemotProductionTranslationKey)
                        })
                    }

                    break
                }
                case EmailTemplateRelations.EmailTemplateRecipients.expert.value: {
                    let listExpertEmail = expertEmail ? [{
                        value: expertEmail,
                        label: _(recipientTranslationKey)
                    }] : []

                    resultEmailList = resultEmailList.concat(listExpertEmail)
                    break
                }
                case EmailTemplateRelations.EmailTemplateRecipients.counterParty.value: {
                    let listEmailCounterParty  = emailCounterParty ? [{
                        value: emailCounterParty,
                        label: _(recipientTranslationKey)
                    }] : []

                    resultEmailList = resultEmailList.concat(listEmailCounterParty)
                    break
                }
                case EmailTemplateRelations.EmailTemplateRecipients.companyCancellations.value: {
                    resultEmailList = companyCancelMail && companyCancelMail.length > 0 ? [{
                        value: companyCancelMail,
                        label: _(recipientTranslationKey)
                    }] : []
                    break
                }
                case EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value: {
                    resultEmailList = tarificationManagerMail && tarificationManagerMail.length > 0 ? [{
                        value: tarificationManagerMail,
                        lang: tarificationManagerLanguage,
                        label: _(recipientTranslationKey)
                    }] : []
                }

                default: {
                    //resultEmailList = []
                }
            }
        }

        if (willemotInCc && !resultEmailList.find(recipient => recipient.value === contractManagerMail && recipient.isCC)){
            resultEmailList.push({
                value: contractManagerMail,
                lang: contractManagerLanguage,
                // must use the translated recipient label (requirement)
                isPermanentSelected: true,
                isCC: true,
                label: _(willemotProductionTranslationKey)
            })
        }

        // inject the recently used to the end, filtered the duplicates
        recentEmailAddresses.forEach((oneEmail) => {
            // check if email address already in list
            let matchedEmails = resultEmailList.filter((elem) => (elem.value === oneEmail.value))

            // if not exists in the already composed list, then we can push it into the list
            if (!matchedEmails.length) {
                resultEmailList.push({value: oneEmail.value, lang: oneEmail.lang, label: '', isRecent: true})
            }
        })

        return resultEmailList
    }

    /**
     * This will set the form value content in store
     */
    async updateFormValue(value, field) {
        const {dispatch} = this.props

        await dispatch({
            type: "redux-form/CHANGE",
            field: field.name,
            value: value && value.value || '',
            touch: value && value.touched || field.touched,
            form: "emailSender"
        })

        // set the initial sate of validation for buttons
        // const hasErrorsValue = this.hasErrors() || this.state.precacheInProgress
        // console.log("hasErrorsValue" , hasErrorsValue)
        // this.props.dataCallbackDisableSend(hasErrorsValue)
    }

    /**
     * This function wil set selected a broker from the list and initialize the "from" email list values.
     * @param {string} selectedBrokerNumber
     */
    onChangeBroker(value, config = null) {
        let {moduleOptions} = this.state

        // change self value of the template dropdown
        // this.updateFormValue(value, fields.brokerField)
        const {dispatch, fields: {brokerField, emailTemplateField}} = this.props

        // initial/overwrite configuration for the modal
        const modalConfiguration = {
            modalTitle: config && config.modalTitle || _("areYouSure"),
            modalMessage: config && config.modalMessage || _("areYouSureToChangeBroker")
        }

        const brokerFakeField = {
            value: value
        }

        // no reset on no change
        if (brokerField && value && brokerField.value === value.value) {
            return
        }

        // if (!brokerField || underscore.isEmpty(brokerField.value)) {

        // don't want to use the confirmation dialog, when no template selected
        if (!emailTemplateField || underscore.isEmpty(emailTemplateField.value)) {
            moduleOptions = this.doTheBrokerChange(moduleOptions, brokerFakeField)
        } else {
            dispatch(showEmailSenderConfirmationModal(
                "emailConfModal",
                modalConfiguration.modalTitle,
                modalConfiguration.modalMessage,
                "changeBroker",
                brokerFakeField
            ))
        }

        this.setState({moduleOptions})
    }

    /**
     * This function handle the change of the mail broker. Trigger all of the events what
     * do things what are affected by this change.
     * @param {object} brokerFakeField
     * @param {object} moduleOptions
     */
    async doTheBrokerChange(moduleOptions, brokerFakeField = null) {
        const {dispatch, fields, options: {confirmationModal}} = this.props

        const modalPayload = brokerFakeField || confirmationModal && confirmationModal.payload
        const {value} = modalPayload

        // select broker and reset the form
        this.updateFormValue(value, fields.brokerField)

        // update the module options for the template usage (variables, etc.) and to save the new brokerNumber
        let setAsBrokerNumberValue = !(value && value.value) ? '' : value.value

        // if there are no broker selected (only client profile own this methods) clear the selected from address
        if (!setAsBrokerNumberValue) {

            this.updateFormValue({value: ''}, fields.emailFromField)
        }

        // get the recently used email addresses to extend the recipient list
        // the IE not support the finally, so we must do almost the same thing in catch also.
        let emailRecentRecipientsResult = await dispatch(loadEmailRecentRecipients(setAsBrokerNumberValue))

        moduleOptions = this.getUpdatedModuleOptionsByBrokerFromOffice(moduleOptions, setAsBrokerNumberValue) //sync call
        // overwrite the recent addresses by the result
        moduleOptions.emailRecentRecipients = emailRecentRecipientsResult

        this.initializeSignatures(moduleOptions.brokerNumber)

        // v8: in case when the broker is changed but the auto selection is on,
        // must be selected the template, dont leave as blank like before
        let selectedTemplateVal = (fields.emailTemplateField && fields.emailTemplateField.value) ||
            (moduleOptions.autoSelectTemplate && {value: "0"}) ||
            null

        this.doTheTemplateSwitch(moduleOptions.brokerNumber, moduleOptions.clientLanguage, selectedTemplateVal, moduleOptions.brokerEmailAddress)

        return moduleOptions
    }

    /**
     * This function will reset your form elements, and insert the default values
     * @param {Object} templateObj
     */
    onChangeEmailTemplate(templateObj) {
        const {dispatch, fields: {emailTemplateField}} = this.props
        let {moduleOptions} = this.state
        // no reset on no change
        if (emailTemplateField && templateObj && emailTemplateField.value === templateObj.value) {
            return
        }
        // when we do the first change or we just change from nothing to something we
        // don't want to use the confirmation dialog, no sens to ask the user to prevent reset of fields
        if (!emailTemplateField || underscore.isEmpty(emailTemplateField.value)) {
            this.doTheTemplateSwitch(moduleOptions.brokerNumber,  moduleOptions.clientLanguage, templateObj) //, moduleOptions.brokerEmailAddress
        } else {
            dispatch(showEmailSenderConfirmationModal(
                "emailConfModal",
                _("areYouSure"),
                _("areYouSureToChangeTemplate"),
                "changeTemplate",
                templateObj
            ))
        }
    }

    /**
     * This function will return a list of email of Willemot recipient by a list of id-s from template.
     * @param {Array} emailIds
     */
    getRecipientWillemotEmailsByIds(emailIds) {
        const {recipientWillemotEmails} = this.props.options

        if (!recipientWillemotEmails || !Array.isArray(recipientWillemotEmails) ||
            (recipientWillemotEmails.length == 0) ) {
            return []
        }

        if (!emailIds || !Array.isArray(emailIds) || (emailIds.length == 0) ) {
            return []
        }

        let result = []
        let obsoleteEmailsIds = []

        emailIds.forEach((item, itemIndex) => {
            let emailFound = false
            recipientWillemotEmails.forEach((oneFromAllItem) => {
                if (oneFromAllItem._id == item.value) {
                    emailFound = true
                    result.push({
                        value: oneFromAllItem.email,
                        label: oneFromAllItem.name.first + " " + oneFromAllItem.name.last,
                        lang: oneFromAllItem.language,
                        id: item.value
                    })
                }
            })

            if (!emailFound) {
                obsoleteEmailsIds.push(item.value)
            }
        })

        // eliminate from result the obsolete emails
        if (obsoleteEmailsIds.length > 0 && result.length > 0) {
            result = result.filter((item) => {
                return (obsoleteEmailsIds.indexOf(item.id) === -1)
            })
        }

        return result
    }

    /**
     * This function will return language of Willemot recipient by a email address
     * @param {string} email
     */
    getRecipientWillemotEmailsLangByEmail(email) {
        const {recipientWillemotEmails} = this.props.options

        if (!recipientWillemotEmails || !Array.isArray(recipientWillemotEmails) ||
            (recipientWillemotEmails.length == 0) ) {
            return ''
        }

        if (!email) {
            return ''
        }

        let result = ''

        recipientWillemotEmails.forEach((oneFromAllItem) => {
            if (oneFromAllItem.email == email) {
                result = oneFromAllItem.language
            }
        })

        return result
    }

    /**
     * This function effecting the change of template of the email.
     * Reset values and filling with the new ones.
     * @param {*} brokerNumber
     * @param {*} clientLanguage
     * @param {*} templateObjPredictive
     * @param {*} brokerEmailAddress optional, use just as initial value on did mount, or on broker change.
     */
    doTheTemplateSwitch(brokerNumber, clientLanguage, templateObjPredictive = null, brokerEmailAddress = null) {
        const {fields, options: {confirmationModal, moduleKey, EmailTemplateRelations, moduleOptions}} = this.props
        const preselectedTemplateObject = templateObjPredictive || confirmationModal && confirmationModal.payload
        const isClientProfileModule = (moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value)

        // no language selected by user, we will set the best available choice
        const language = nesProp.get(fields, 'emailLanguageField.value') || this.fetchRecipientLanguage(clientLanguage)

        // change self value of the template dropdown
        this.updateFormValue(preselectedTemplateObject, fields.emailTemplateField)

        // reset form fields on by one, because this verion of redux for not support the global reset
        this.updateFormValue('', fields.recipientField)
        this.updateFormValue({value: language}, fields.emailLanguageField)
        //this.updateFormValue('', fields.signatureField)

        let selectedTemplate = this.getNewSelectedTemplate(preselectedTemplateObject && preselectedTemplateObject.value || '')
        let templateContent = this.getNewTemplateContent(selectedTemplate)
        let templateRecipients = this.getNewTemplateRecipients(templateContent, moduleOptions)
        let defaultRec = this.makeSelectedDefaultRecipient(templateRecipients, moduleOptions)
        let emailToOptions = this.getNewEmailToOptions('', templateRecipients, templateContent, selectedTemplate.willemotInCC)
        let emailFromOptions = this.getNewEmailFromOptions()

        this.setState({emailFromOptions, emailToOptions, templateRecipients, templateContent})

        // on profile module without selected brokerNumber we can not preselect email addresses
        if (brokerNumber || !isClientProfileModule) {
            // when no "brokerEmailAddress" is set in module option we will select the first email address form the list
            let firstEmailAddress = emailFromOptions && emailFromOptions.length > 0 ? emailFromOptions[0].value : ''

            this.updateFormValue({value: (brokerEmailAddress || firstEmailAddress)}, fields.emailFromField)
            // reset the from address and name
            let selectedEmailFromName = this.getNewEmailFromName(firstEmailAddress, emailFromOptions)
            this.setState({selectedEmailFromName: selectedEmailFromName})
        }

        this.setState({variables: []})

        this.fetchEmailModuleVariableRealValues(selectedTemplate, language)

        // reset the tinymce editor content
        let recipientToUseByDefault = ''
        if (defaultRec && defaultRec.value) {
            recipientToUseByDefault = defaultRec.value
        }

        let fillResult = this.fillEditorValueOnChanges(recipientToUseByDefault, fields.emailLanguageField.value, templateContent)

        this.updateFormValue({value: fillResult.processedSubject}, fields.subjectField)
        this.updateFormValue({value: fillResult.body, touched: Boolean(fillResult.body) || fields.emailBodyField.touched}, fields.emailBodyField)

        // v8
        // working with multilanguage optionally
        let nlResult = this.fillEditorValueOnChanges(fields.recipientField.value, 'nl', templateContent)
        let frResult = this.fillEditorValueOnChanges(fields.recipientField.value, 'fr', templateContent)


        if (defaultRec) {

            // by the recipient switch we also do the body editor reset, then we dont have to do again
            let isThisAutomaticFirstStepSelection = true
            this.doTheRecipientSwitch(
                defaultRec.value,
                templateRecipients,
                templateContent,
                isThisAutomaticFirstStepSelection,
                selectedTemplate.willemotInCC,
                selectedTemplate
            )
        } else {

            // preselect a content
            let body = nlResult.body
            if (
                (fields.emailLanguageField && fields.emailLanguageField.value && fields.emailLanguageField.value == 'fr') ||
                language
            ) {
                body = frResult.body
            }

            this.initializeBodyEditor(body, false, fields.emailLanguageField.value)
        }

        // put back all the stuffs
        this.setState({
            activeLanguageTabValue: fields.emailLanguageField.value,
            nlLanguageTabBodyValue: this.parseAndReplaceVariables(nlResult.body, "nl"),
            nlLanguageTabSubjectValue: this.parseAndReplaceVariables(nlResult.processedSubject, "nl"),
            frLanguageTabBodyValue:  this.parseAndReplaceVariables(frResult.body, "fr"),
            frLanguageTabSubjectValue: this.parseAndReplaceVariables(frResult.processedSubject, "fr"),
        })
    }

    /**
     * This function will use to handle the recipient switch.
     * @param {object} value
     * @param {Object} templateRecipients
     * @param {String} templateContent
     */
    onChangeRecipient(event, templateRecipients, templateContent) {
        const {dispatch, fields: {recipientField, emailTemplateField}} = this.props
        const recipientInputValue = event.target.value
        const selectedTemplate = this.getNewSelectedTemplate(emailTemplateField.value || '')
        // no reset on no change
        if (recipientField && recipientField.value === recipientInputValue) {
            return false
        }

        // when we do the first change or we just change from nothing to something we
        // don't want to use the confirmation dialog, no sens to ask the user to prevent reset of fields
        if (!recipientField || underscore.isEmpty(recipientField.value)) {
            // reset the almost everything always when recipient changed, so here we start a flag "isThisAutomaticFirstStepSelection"
            let isThisAutomaticFirstStepSelection = true
            this.doTheRecipientSwitch(recipientInputValue, templateRecipients, templateContent,
                isThisAutomaticFirstStepSelection, selectedTemplate.willemotInCC, selectedTemplate)
            return true
        } else {
            const payload = {
                value: recipientInputValue,
                templateRecipients,
                templateContent,
                willemotInCC: selectedTemplate.willemotInCC
            }

            dispatch(showEmailSenderConfirmationModal(
                "emailConfModal",
                _("areYouSure"),
                _("areYouSureToChangeRecipient"),
                "changeRecipient",
                payload
            ))

            return false
        }
    }

    /**
     * This function switch the recipient of mail.
     * This function will reset the email address dropdown, subject and body.
     * @param {string} value - the selected recipient value like 'willemotProduction' or 'claims' etc.
     * @param {object} templateRecipients - contains the list of possible recipients for the template
     * @param {object} templateContent - the template content object
     * @param {bool} isThisAutomaticFirstStepSelection - this is true by default, means the change flow started,
     * @param {bool} willemotInCC forced willemot email in cc,
     * @param {object} selectedTemplate - this is slected template,
     *  and forget about the custom changes, reset everything
     */
    doTheRecipientSwitch(value = null, templateRecipients = null, templateContent = null, isThisAutomaticFirstStepSelection = true,
        willemotInCC = false, selectedTemplate = null) {
        const {fields, options: {EmailTemplateRelations, confirmationModal}, emailTemplateField} = this.props

        const selectedRecipient = value || nesProp.get(confirmationModal, "payload.value")
        const templateRecipientsFinal = templateRecipients || nesProp.get(confirmationModal, "payload.templateRecipients")
        const templateContentFinal = templateContent || nesProp.get(confirmationModal, "payload.templateContent")

        if (!willemotInCC) {
            willemotInCC = nesProp.get(this.props, "options.confirmationModal.payload.willemotInCC") || false
        }

        this.updateFormValue({value: selectedRecipient}, fields.recipientField)

        let emailToOptions = this.getNewEmailToOptions(selectedRecipient, templateRecipientsFinal, templateContentFinal, willemotInCC)

        let firstToAddress = nesProp.get(emailToOptions, '0')

        // all exept first
        let allWhatMustBeSelectedForTo = emailToOptions.slice(1).filter((oneToOption) => (!oneToOption.isRecent && oneToOption.isPermanentSelected))

        let addressesToSelect = firstToAddress && !firstToAddress.isRecent ? [firstToAddress] : []
        addressesToSelect = addressesToSelect.concat(allWhatMustBeSelectedForTo)

        // when willemot is the recipient select all the fields fo to field, because this
        if (selectedRecipient == EmailTemplateRelations.EmailTemplateRecipients.willemot.value) {
            addressesToSelect = emailToOptions.filter((oneToOption) => (!oneToOption.isRecent))
        }

        // when company is the recipient or willemotInCC select the willemot in CC

        if (willemotInCC || selectedRecipient == EmailTemplateRelations.EmailTemplateRecipients.company.value) {
            addressesToSelect = addressesToSelect.concat(
                emailToOptions.filter(
                    (oneToOption) => (
                        oneToOption.isPermanentSelected && addressesToSelect.find(
                            address => (address.value !== oneToOption.value)
                        )
                    )
                )
            )
        }

        let filteredTos =  addressesToSelect.filter((oneSelectedAddress)=>{return !oneSelectedAddress.isCC})
        let filteredCCs =  addressesToSelect.filter((oneSelectedAddress)=>{return !!oneSelectedAddress.isCC})

        this.onChangeRecipientEmail(
            selectedRecipient,
            filteredTos,
            templateContentFinal,
            isThisAutomaticFirstStepSelection,
            selectedTemplate
        )
        this.onChangeRecipientEmailCC(filteredCCs)

        let variables = this.getNewVariables(templateContentFinal, selectedRecipient)

        // v8
        // restricting tu use the global link: F2FSigningUrl- can not be sent for all the same link
        variables = variables.filter((oneVar) => (oneVar.value !== "F2FSigningUrl"))

        this.setState({
            variables,
            emailToOptions,
            isCCShown: false
        })
    }

    /**
     * This function handle the event of the sender email address changing.
     * @param {*} value
     */
    onChangeEmailFromAddress(value) {
        const {fields} = this.props

        let selectedEmailFromName = this.getNewEmailFromName(value.value, this.state.emailFromOptions)
        this.setState({selectedEmailFromName: selectedEmailFromName},() => {
            this.forceUpdate()
        })
        this.updateFormValue(value, fields.emailFromField)
    }

    /**
     * This is an event what give you a confirmation dialog to decide if you want to change the  language or not.
     * Handle the user choice, and fire the language changing if necessary.
     * @param {*} recipient
     * @param {*} requiredLanguage
     * @param {*} templateContent
     * @param {*} config
     */
    openAskingModalForLanguageChange(recipient, requiredLanguageObj, templateContent, config = null) {
        const {dispatch, fields: {emailLanguageField}} = this.props

        // initial/overwrite configuration for the modal
        const modalConfiguration = {
            modalTitle: config && config.modalTitle || _("areYouSure"),
            modalMessage: config && config.modalMessage || _("areYouSureToChangeLanguage")
        }

        const payload = {
            value: requiredLanguageObj.value,
            templateContent
        }

        // no reset on no change
        if (emailLanguageField && emailLanguageField.value === requiredLanguageObj.value) {
            return
        }

        // when we do the first change or we just change from nothing to something we
        // don't want to use the confirmation dialog, no sens to ask the user to prevent reset of fields
        if (!emailLanguageField || underscore.isEmpty(emailLanguageField.value)) {
            this.doTheLanguageChange(recipient, payload)
        } else {
            dispatch(showEmailSenderConfirmationModal(
                "emailConfModal",
                modalConfiguration.modalTitle,
                modalConfiguration.modalMessage,
                "changeLanguage",
                payload
            ))
        }
    }

    /**
     * This function handle the change of the mail language. Trigger all of the events what
     * do things what are affected by this change.
     * @param {*} recipient
     * @param {*} forcePayload This function is called by a confirmation momdal what have payload to use from props.
     * But this argument let to override the payload, whent it is used by hande somwhere else.
     * @param {*} selectedTemplate
     */
    doTheLanguageChange(recipient, forcePayload = null, selectedTemplate = null) {
        const {fields, options: {confirmationModal}} = this.props

        // determine the source fo data
        const languageAndTemplateFromModal = confirmationModal && confirmationModal.payload
        const languageAndTemplate = forcePayload || languageAndTemplateFromModal

        // fetch used values from data
        const templateContent = languageAndTemplate.templateContent
        const language = languageAndTemplate.value

        let selectedTemplateVal
        // refresh template variables on language switch
        if (!selectedTemplate) {
            selectedTemplateVal = nesProp.get(fields, "emailTemplateField.value") || ''
            selectedTemplate = this.getNewSelectedTemplate(selectedTemplateVal)
        }

        this.fetchEmailModuleVariableRealValues(selectedTemplate, language)

        // update the form field by the new language seted
        this.updateFormValue({value: language}, fields.emailLanguageField)

        let fillResult = this.fillEditorValueOnChanges(recipient, language, templateContent)

        this.updateFormValue({value: fillResult.processedSubject}, fields.subjectField)
        // touched if once got a value what was not empty
        this.updateFormValue({value: fillResult.body, touched: Boolean(fillResult.body) || fields.emailBodyField.touched}, fields.emailBodyField)

        this.initializeBodyEditor(fillResult.body, recipient, language)
    }

    /**
     * Event when change recipient email address. Also handle the recipient language change.
     * @param {string} selectedRecipient actual recipient value
     * @param {*} emailValuesArray the allowed email addresses list filtered by the user selected conditions.
     * @param {*} templateContent The template
     * @param {*} isThisAutomaticFirstStepSelection a falg when the modal is loaded and the values are
     * automatically selected to decide if the asking modal is required.
     * @param {*} selectedTemplate
     */
    onChangeRecipientEmail(selectedRecipient, emailValuesArray, templateContent,
            isThisAutomaticFirstStepSelection = false, selectedTemplate = null) {
        const {dispatch, fields, fields: {emailToSelectField, emailLanguageField}} = this.props
        const {emailToOptions} = this.state
        // let recipient =  fields.recipientField.value
        let moduleOptions = nesProp.get(this.state, "moduleOptions") || {}
        const brNr = moduleOptions.brokerNumber

        // if we have selected recipient we try to use the language of the first recipient
        let firstRecipient = nesProp.get(emailValuesArray, '0.value')
        let determinedRecLanguage = this.fetchRecipientLanguage(moduleOptions.clientLanguage, firstRecipient)

        // no question change or ask the user by a confirmation modal
        if (isThisAutomaticFirstStepSelection) {
            this.doTheLanguageChange(
                selectedRecipient,
                {
                    value: determinedRecLanguage,
                    templateContent
                },
                selectedTemplate
            )
        } else {
            this.openAskingModalForLanguageChange(
                selectedRecipient,
                {value: determinedRecLanguage},
                templateContent,
                {modalMessage: _('areYouSureToChangeLanguageByRecipient')}
            )
        }

        // add currently selected email address to the recently used email-addresses list (if exists then increase the usage count, for sort)
        let selectedOldValues = nesProp.get(emailToSelectField, "value") || []
        let selectedNewValues = emailValuesArray || []

        let oldEmailCount = Array.isArray(selectedOldValues) && selectedOldValues.length || 0
        let lastOldEmail = nesProp.get(selectedOldValues, (oldEmailCount-1)+".value") || ''

        let newEmailCount = Array.isArray(selectedNewValues) && selectedNewValues.length || 0
        let lastNewEmail = nesProp.get(selectedNewValues, (newEmailCount-1)+".value") || ''

        let mustSend = true
        if (oldEmailCount >= newEmailCount || isThisAutomaticFirstStepSelection) {
            mustSend = false
        }

        if (brNr && lastNewEmail && mustSend) {
            dispatch(addEmailRecentRecipients(brNr, lastNewEmail, determinedRecLanguage))

            // add to the option list if not exists
            let found = emailToOptions && emailToOptions.filter((oneItem) => (oneItem.value === lastNewEmail))

            if (!found || found.length == 0) {
                emailToOptions.push({name: '', label: "<"+lastNewEmail+">", value: lastNewEmail, isRecent: true})
                this.setState({emailToOptions: emailToOptions})
            }
        }

        this.initializeSignatures(moduleOptions.brokerNumber)

        this.setState({moduleOptions})

        this.updateFormValue({value: emailValuesArray}, emailToSelectField)
    }

    /**
     * This function will remove an option from email to list
     * @param {String} email
     */
    removeRecent(email) {
        const {dispatch} = this.props
        const moduleOptions = nesProp.get(this.state, "moduleOptions")
        const {emailToOptions} = this.state
        const brNr = moduleOptions.brokerNumber
        dispatch(removeEmailRecentRecipients(brNr, email)).then(()=>{
            // remove from the option list if exists
            let found = emailToOptions && emailToOptions.filter((oneItem) => (oneItem.value !== email))

            if (found.length !== emailToOptions.length) {
                this.setState({emailToOptions: found})
            }
        })
    }

    /*
     * Event when change recipient email address. Also handle the recipient language change.
     */
    onChangeRecipientEmailCC(emailValuesArray) {
        const {dispatch, fields: {emailToSelectFieldCC}} = this.props
        const {emailToOptions} = this.state
        let moduleOptions = nesProp.get(this.state, "moduleOptions") || {}
        const brNr = moduleOptions.brokerNumber

        // if we have selected recipient we try to use the language of the first recipient
        let firstRecipient = nesProp.get(emailValuesArray, '0.value')
        let determinedRecLanguage = this.fetchRecipientLanguage(moduleOptions.clientLanguage, firstRecipient)

        // add currently selected email address to the recently used email-addresses list (if exists then increase the usage count, for sort)
        let selectedOldValues = nesProp.get(emailToSelectFieldCC, "value") || []
        let selectedNewValues = emailValuesArray || []

        let oldEmailCount = Array.isArray(selectedOldValues) && selectedOldValues.length || 0
        let lastOldEmail = nesProp.get(selectedOldValues, (oldEmailCount-1)+".value") || ''

        let newEmailCount = Array.isArray(selectedNewValues) && selectedNewValues.length || 0
        let lastNewEmail = nesProp.get(selectedNewValues, (newEmailCount-1)+".value") || ''

        let mustSend = true
        if (oldEmailCount >= newEmailCount) {
            mustSend = false
        }

        if (brNr && lastNewEmail && mustSend) {
            dispatch(addEmailRecentRecipients(brNr, lastNewEmail, determinedRecLanguage))

            // add to the option list if not exists
            let found = emailToOptions && emailToOptions.filter((oneItem) => (oneItem.value === lastNewEmail))

            if (!found || found.length == 0) {
                emailToOptions.push({name: '', label: "<"+lastNewEmail+">", value: lastNewEmail, isRecent: true})
                this.setState({emailToOptions: emailToOptions})
            }
        }

        this.initializeSignatures(moduleOptions.brokerNumber)

        this.setState({moduleOptions})

        this.updateFormValue({value: emailValuesArray}, emailToSelectFieldCC)
    }

    /**
     * Update the the content of the editors by replace variable values on the specific language.
     */
    fillEditorValueOnChanges(selectedRecipient, language, templateContent) {
        const {fields, options: { EmailTemplateRelations }} = this.props

        const subject = !underscore.isEmpty(templateContent) &&
            !underscore.isEmpty(templateContent.content[selectedRecipient]) &&
            !underscore.isEmpty(templateContent.content[selectedRecipient][language]) &&
            !underscore.isEmpty(templateContent.content[selectedRecipient][language].subject) &&
            templateContent.content[selectedRecipient][language].subject || ''

        const body = !underscore.isEmpty(templateContent) &&
            !underscore.isEmpty(templateContent.content[selectedRecipient]) &&
            !underscore.isEmpty(templateContent.content[selectedRecipient][language]) &&
            !underscore.isEmpty(templateContent.content[selectedRecipient][language].body) &&
            templateContent.content[selectedRecipient][language].body || ''

        // for subject here we replace the variables because this is not dynamic like the body
        const processedSubject = this.parseAndReplaceVariables(subject, language)

        return {body, processedSubject}
    }

    /**
     * This function provide a reference to an icon on a safe way. If icon not found
     * return with a placeholder icon reference
     */
    getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        }catch(err){
            return require(`resources/images/ic_do_not_disturb_black_24px.svg`)
        }
    }

    /**
     * This function will remove an attachment from selected list
     * @param {object} file
     */
    removeAttachment(file) {
        let {attachments, moduleSpecificClaimAttachemnts, moduleSpecificContractAttachemnts, moduleSpecificClientAttachemnts,
            moduleSpecificTarificationAttachemnts, moduleSpecificTicketAttachemnts} = this.state

        moduleSpecificClaimAttachemnts = moduleSpecificClaimAttachemnts.filter((oneAtt)=>{
            return (oneAtt.id !== file.id)
        })

        moduleSpecificContractAttachemnts = moduleSpecificContractAttachemnts.filter((oneAtt)=>{
            return (oneAtt.id !== file.id)
        })

        moduleSpecificClientAttachemnts = moduleSpecificClientAttachemnts.filter((oneAtt)=>{
            return (oneAtt.id !== file.id)
        })

        moduleSpecificTarificationAttachemnts = moduleSpecificTarificationAttachemnts.filter((oneAtt)=>{
            return (oneAtt.id !== file.id)
        })

        moduleSpecificTicketAttachemnts = moduleSpecificTicketAttachemnts.filter((oneAtt)=>{
            return (oneAtt.id !== file.id)
        })

        attachments = attachments.filter((oneAtt)=>{
            return (oneAtt.id !== file.id)
        })

        this.setState({
            moduleSpecificClaimAttachemnts,
            moduleSpecificContractAttachemnts,
            moduleSpecificClientAttachemnts,
            moduleSpecificTarificationAttachemnts,
            moduleSpecificTicketAttachemnts,
            attachments
        })
    }

    /**
     * This function will remove a hard attachment from selected list
     * @param {Number} fileIndex
     */
    removeHardAttachment(fileIndex) {
        let {hardAttachments} = this.state

        hardAttachments = hardAttachments.filter((oneAtt, index)=>{
            return (index !== fileIndex)
        })

        this.setState({hardAttachments})
    }

    /**
     * This function will open an attached document in new window.
     * @param {*} file
     */
    openAttachment(file) {
        window.open(`/data/document?localId=${file.localId}`, '_blank', 'noopener,noreferrer')
    }


    /**
     * This function will do a precache for a list of documents and fire a callback function
     * with the extended values
     * @param {array} attachments - list of documents -> id, date, docType
     * @param {*} callBack
     */
    doThePrecache(attachments, callBack=null) {
        const {dispatch} = this.props
        let precachers = [], noLoader = true

        // prepare lot of promises parallell
        attachments.forEach((att) => {
            precachers.push(
                dispatch(preCacheDocuments(att, noLoader))
                .catch((err)=>{
                    // do not show individual toaster message, and catch error to keep the then branch for promise
                    //dispatch(setNotification(_('attachmentNotFound') +' '+ att.name, 'error'))
                    console.error(err)
                    return err
                })
            )
        })

        // pop up the modal
        dispatch(showEmailSenderConfirmationModal(
            "waitingModal",
            _("pleaseWaitModalTitle"),
            _("pleaseWaitModalMessage"),
            "",
            null
        ))

        return Promise.all(precachers).then(
            (results) => {
                let errorPrecacheList = []

                dispatch(hideEmailSenderConfirmationModal("waitingModal", true))

                // let attachemntsWhatCached = []
                // find the related attachment to give back the local id
                if (attachments && attachments.length > 0 && results && results.length > 0 &&
                    results.length == attachments.length) {

                    attachments.forEach((attVal, attindex) => {
                        results.forEach((resVal, resIndex)=>{
                            if (attVal.id == nesProp.get(resVal, "data.id")) {
                                attVal.localId = nesProp.get(resVal, "data.localId")
                            }
                        })

                        if (!attVal.localId) {
                            errorPrecacheList.push(attVal.aliasFileName)
                        }
                    })
                }

                // Display a modal for bad attachments
                if (errorPrecacheList.length > 0) {
                    dispatch(showEmailSenderConfirmationModal(
                        "emailNotSentModal",
                        _("attachmentsNotCachedTitle"),
                        _("attachmentsNotCachedMessage") + " " +errorPrecacheList.join(", "),
                        "emailSent",
                        null
                    ))
                }

                // call the callback passing the extended document list with then localId
                if (typeof callBack === 'function') {
                    callBack(attachments)
                }

                return attachments
        })

        .catch((err)=>{
            console.error(err)
            throw err
        })
    }

    /**
     * Get a general filename for attached files to rename in email attachment.
     * @param {string} originalName
     * @param {string} date
     * @param {string} id
     */
    getDefaultAliasForFileNameInAttachments(originalName, date, id) {
        return originalName + "-" + date + "-" + id
    }

    /**
     * Save the old alias names from the old attachment list into the new assigned by ID-s
     * @param {array} oldAttachments
     * @param {array} newAttachments
     */
    getAttachmentsWithRecycledAliasFilenames(oldAttachments, newAttachments) {
        let resultAtt = []
        if (newAttachments && newAttachments.length > 0) {
            newAttachments.forEach((newDoc) => {
                if (oldAttachments && oldAttachments.length > 0) {
                    oldAttachments.forEach((doc) => {
                        if (doc.id == newDoc.id && newDoc.aliasFileName !== doc.aliasFileName) {
                            newDoc.aliasFileName = doc.aliasFileName
                        }
                    })
                }
                // insert in to the result the attachment anyway, does not matter if alias is updated or not
                resultAtt.push({
                    ...newDoc
                })
            })
        }

        return resultAtt
    }

    /**
     * This function will transform the uploader provided document result to a structure for attachments
     * @param {array} selectedUploaderDocs
     */
    fetchAttachmentsFromUploaderSelectionDocList (selectedUploaderDocs) {
        let resultAtt = []

        if (!underscore.isEmpty(selectedUploaderDocs)) {
            selectedUploaderDocs.forEach((doc) => {

                let formatedDate = doc.date

                if (formatedDate) {
                    formatedDate = moment(doc.date)
                    if (formatedDate.isValid()) {
                        formatedDate = moment(doc.date).format('DD-MM-YYYY')
                    } else {
                        formatedDate = doc.date
                    }
                }

                resultAtt.push({
                    name: doc.name,
                    date: formatedDate,
                    aliasFileName: this.getDefaultAliasForFileNameInAttachments(doc.name, formatedDate, doc.id),
                    id: doc.id,
                    oracleDocumentId: doc.id, // added because the ticket document selector
                    localId: '',
                })
            })
        }

        return resultAtt
    }

    /**
     * This function will effect the attaching of document to the attachment list.
     * @param {array} selected0 - 1th list of documents related by opened module
     * @param {array} selected - 2th list of documents related by opened module
     * @param {array} selected2 - list of documents of client module if current module not equal with client module
     * @param {array} selected3 - list of documents of tarification module if current module not equal with tarification module
     */
    handleConfirmSelectedAttachments (selected0, selected1, selected2=[], selected3=[], selected4=[]) {
        let attachments = []

        // add attachments from default document list of current module
        let moduleSpecificClaimAttachemnts = this.fetchAttachmentsFromUploaderSelectionDocList(selected0)
        this.setState({moduleSpecificClaimAttachemnts})

        // add attachments from default document list of current module
        let moduleSpecificContractAttachemnts = this.fetchAttachmentsFromUploaderSelectionDocList(selected1)
        this.setState({moduleSpecificContractAttachemnts})

        // add attachments from default document list of current module
        let moduleSpecificTarificationAttachemnts = this.fetchAttachmentsFromUploaderSelectionDocList(selected3)
        this.setState({ moduleSpecificTarificationAttachemnts })

        // add attachments from default document list of current module
        let moduleSpecificTicketAttachemnts = this.fetchAttachmentsFromUploaderSelectionDocList(selected4)
        this.setState({ moduleSpecificTicketAttachemnts })

        // add attachments from optional document list of current module
        let moduleSpecificClientAttachemnts = this.fetchAttachmentsFromUploaderSelectionDocList(selected2)
        this.setState({moduleSpecificClientAttachemnts})

        // merge all selected lists together for show
        attachments = moduleSpecificClaimAttachemnts.concat(moduleSpecificClientAttachemnts)
        attachments = moduleSpecificContractAttachemnts.concat(attachments)
        attachments = moduleSpecificTarificationAttachemnts.concat(attachments)
        attachments = moduleSpecificTicketAttachemnts.concat(attachments)

        // remove duplicated attachments by ID to avoid to keep the same file twice in the email
        attachments = attachments.reduce((uniqueAttachments, currentAttachment) => {
            const id = currentAttachment.id

            if (!uniqueAttachments.some(attachment => attachment.id === id)) {
                uniqueAttachments.push(currentAttachment)
            }

            return uniqueAttachments
        }, [])

        // find already edited filenames and associate by ID
        attachments = this.getAttachmentsWithRecycledAliasFilenames(this.state.attachments, attachments)

        // attachments precache -> update in state -> update in fields for validate
        this.setState({attachments: attachments}, () => {
            if (!underscore.isEmpty(this.state.attachments)) {
                // set flag for visual elements (waiting modal etc.)
                this.setState({precacheInProgress: true}, ()=>{
                    this.forceUpdate()
                })

                // start the caching
                this.doThePrecache(
                    this.state.attachments,
                    (extendedAttachemntsWithLocalId) => {

                        // remove files from old state, what are can not be cached from any reason
                        if (extendedAttachemntsWithLocalId) {
                            extendedAttachemntsWithLocalId.forEach((oneFile)=>{
                                if (!oneFile.localId) {
                                    this.removeAttachment(oneFile)
                                }
                            })
                        }

                        // update attachments list again by only the successfully cached values
                        this.setState({attachments: extendedAttachemntsWithLocalId.filter((oneAttachment)=>Boolean(oneAttachment.localId))},
                            () => { this.updateValidationFieldForAttachments() }
                        )
                    }

                )
                // the same action in "catch" and "then" because the "finally" not supported in IE
                .then((result)=>{
                    this.setState({precacheInProgress: false}, ()=>{
                        this.forceUpdate()
                    })
                    return result
                })
                .catch((err)=>{
                    this.setState({precacheInProgress: false}, ()=>{
                        this.forceUpdate()
                    })
                    return err
                })
            }
        })
    }

    /**
     * Open the attachment modal to attach the documents
     */
    modalEmailAttach() {
        const {dispatch} = this.props
        dispatch(showEmailSenderAttachmentModal(
            "emailConfModal",
            _("attaching"),
            _("pleaseAttach"),
            "attach",
            null
        ))
    }

    /**
     * This function just update the field value of the field "attachmentsForValidateOnly"
     * using all of the attachments
     */
    updateValidationFieldForAttachments() {
        let allAttachmentTogether = [].concat(this.state.attachments || [])
            .concat(this.state.hardAttachments || [])
        this.updateFormValue({value: allAttachmentTogether, touched: true}, this.props.fields.attachmentsForValidateOnly)
    }

    /**
     * This function will reinsert a new file name alias in attachments list used a file id reference
     * @param {*} value
     * @param {*} file
     */
    onChangeAliasFileName (value, file) {
        let attachments = this.state.attachments

        attachments.forEach((attVal, attIndex) => {
            if (attVal.id == file.id) {
                attachments[attIndex].aliasFileName = value
            }
        })

        this.setState({attachments: attachments}, this.updateValidationFieldForAttachments)
    }

    /**
     * This function will reinsert a new file name alias in attachments list used a file id reference
     * @param {*} value
     * @param {Number} fileIndex
     */
    onChangeAliasHardFileName (value, fileIndex) {
        let hardAttachments = this.state.hardAttachments

        hardAttachments.forEach((attVal, attIndex) => {
            if (attIndex == fileIndex) {
                hardAttachments[attIndex].aliasFileName = value
            }
        })

        this.setState({hardAttachments: hardAttachments}, this.updateValidationFieldForAttachments)
    }

    /**
     * This function handle the keydown event on input of file name.
     * @param {object} event
     */
    onKeyDownAliasFileName (event) {
        // event.target.focus()
        if (event.key == 'Enter' || event.key == 'Escape') {
            event.target.blur()
        }
        return true
    }

    /**
     * Render the attachment list table
     */
    renderAttachments () {
        const {fields:{attachmentsForValidateOnly}} = this.props
        const {attachments, hardAttachments} = this.state
        return (
            <div className={cs(styles.attachmentsContainer)}>
                <div className={styles.attachRowsContainer}>
                    {!underscore.isEmpty(attachments) && attachments.map((file, fileIndex)=>{
                        return (
                        <div key={"attachmentFileRow"+fileIndex}
                            className={cs(styles.attachRow,
                                this.state.precacheInProgress || file.localId ? "" : styles.attachRowError
                            )}
                            onClick={(e)=>{this.openAttachment(file)}}
                        >
                            <div className={styles.icon}>
                                <img src={this.getIcon('icn-links.svg')}/>
                            </div>
                            <div className={styles.fileName}
                                onClick={(e)=>{
                                    e.stopPropagation()
                            }}>
                                <input
                                    className={styles.fileNameInput}
                                    value={file.aliasFileName}
                                    onChange={(event)=>(this.onChangeAliasFileName(event.target.value, file))}
                                    onKeyDown={this.onKeyDownAliasFileName}
                                />
                            </div>
                            <div className={styles.date}
                            >
                                {file.date}
                            </div>
                            <div className={styles.operation}
                                onClick={(e)=>{
                                    e.stopPropagation()
                                    this.removeAttachment(file)
                            }}>
                                <img src={this.getIcon('a-trash_1x_ovbBlue.svg')}/>
                            </div>
                        </div>
                    )})}

                {hardAttachments && hardAttachments.length > 0 &&
                    hardAttachments.map((file, fileIndex)=>{
                        return (
                        <div key={"attachmentFileRow"+fileIndex}
                            className={cs(styles.attachRow,styles.hardAttachments,
                                (this.state.precacheInProgress || file.localId ? "" : styles.attachRowError)
                            )}
                            onClick={(e)=>{this.openAttachment(file)}}
                        >
                            <div className={styles.icon}>
                                <img src={this.getIcon('icn-links.svg')}/>
                            </div>
                            <div className={styles.fileName}
                                onClick={(e)=>{
                                    e.stopPropagation()
                            }}>
                                <input
                                    className={styles.fileNameInput}
                                    value={file.aliasFileName}
                                    onChange={(event)=>(this.onChangeAliasHardFileName(event.target.value, fileIndex))}
                                    onKeyDown={this.onKeyDownAliasFileName}
                                />
                            </div>
                            <div className={styles.date}
                            >
                                {file.date}
                            </div>
                            <div className={styles.operation}
                                onClick={(e)=>{
                                    let hardOnly = true
                                    e.stopPropagation()
                                    this.removeHardAttachment(fileIndex)
                            }}>
                                <img src={this.getIcon('a-trash_1x_ovbBlue.svg')}/>
                            </div>
                        </div>
                    )})}
                </div>
            </div>
            )
    }

    /**
     * This function will render a label with button icon for attachments
     */
    renderAttachmentsLabel() {
        return (
            <label className={cs(styles.formLabel,styles.leftRightAlign)} htmlFor="attachmentsField">
                <span>{_("attachments")}</span>
                <span>
                    <img src={this.getIcon('icn-link_1x_blue.svg')}
                        onClick={() => this.modalEmailAttach()}
                    />
                </span>
            </label>)
    }

    /**
     * This function will change the opened module (forward browser) to the signature module
     */
    navigateToSignature() {
        const {dispatch} = this.props
        dispatch(setAppModule(c.OFFICE, 'signature'))
    }

    /**
     * This function will change the opened module (forward browser) to the outbox module
     */
    navigateToOutbox() {
        const {dispatch} = this.props
        dispatch(setAppModule(c.OUTBOX))
    }

    /**
     * This function will render the recipient selector for email sender modal.
     * @param {object} templateContent
     * @param {array} templateRecipients
     * @param {bool} allFieldDisabled
     */
    renderRecipientSelector(allFieldDisabled) {
        const {fields: {emailTemplateField, recipientField}} = this.props
        const {templateContent, templateRecipients} = this.state
        const classNameForContainer = (!emailTemplateField || !emailTemplateField.value) ? styles.visibleNone : ""

        return (<div className={cs(styles.formGroup, classNameForContainer)}>
            <div className={cs(styles.inARow,styles.recipientContainer)}>
                {!underscore.isEmpty(templateRecipients) &&
                    <label className={styles.formLabel}
                        htmlFor="recipientField">{_("selectRecipient")}*</label>
                    || null
                }
                <div className={styles.recipientButtonsContainer}>
                    {templateRecipients && templateRecipients
                        .map((rec, recIndex)=>{
                            const recipientTranslationKey = 'recipient'+rec.value.charAt(0).toUpperCase() + rec.value.slice(1)
                            return(
                                <div key={"recKey"+recIndex} className={styles.recipientButton}>
                                    <input type={"radio"}
                                        disabled={allFieldDisabled}
                                        {...recipientField}
                                        value={rec.value}
                                        checked={recipientField.value === rec.value}
                                        onBlur={(e)=>{ return false }}
                                        onChange={(value) =>{
                                            this.onChangeRecipient(value, templateRecipients, templateContent)
                                            return true
                                        }}
                                    />
                                    <label onClick={(e)=>{
                                        (this.onChangeRecipient({target: {value: rec.value}}, templateRecipients, templateContent))
                                    }}>
                                        {_(recipientTranslationKey)}
                                    </label>

                                </div>
                            )}) ||
                            (emailTemplateField && emailTemplateField.value &&
                                <span className={styles}>{_('noRecipientsFound')}</span> || '')
                    }

                </div>
            </div>
        </div>)
    }

    /**
     * This function will return a boolean value what to enable all fields of form.
     * @param {object} emailTemplateField - redux form field object for selecting template
     * @param {object} recipientField - redux form field object for selecting recipient
     */
    isDisabledAllOfTheFields(emailTemplateField, recipientField) {
        return (
            (emailTemplateField.value || emailTemplateField.value == "0") &&
            recipientField.value
        ) ? false : true
    }

    /**
     * This function will change te CC field visibility
     */
    toggleCCFieldShow(forceValue = null) {
        this.setState({isCCShown: forceValue !== null ? forceValue : !this.state.isCCShown})
    }

    /**
     * Main renderer. Rendering full component. All together.
     */
	render() {
        const {fields,
            fields: {emailTemplateField, recipientField, emailLanguageField, emailFromField, emailToSelectField,
                emailToSelectFieldCC, subjectField, emailBodyField, signatureField, attachmentsForValidateOnly, brokerField},
            options: {EmailTemplateRelations, emailConfModalIsOpen, moduleKey,
                emailNotSentModalIsOpen, waitingModalIsOpen, showPreviewModal, hideCC, emailSentModalIsOpen, emailSentModal},
            } = this.props

        // WORKAROUND because of depricated react version
        // we have to clean the defaultChecked prop from the radio button fields because this version of react give a warning
        if (!underscore.isEmpty(recipientField) && underscore.has(recipientField, "defaultChecked")) {
            delete recipientField.defaultChecked
        }

        const {emailServerConfigError} = this.state

        // fetch the initial values of the form from state
        // const {initialEmailLang} = this.state
        const {templateContent, templatesOptions, templateRecipients, emailToOptions, emailFromOptions, selectedEmailFromName,
            langOptions, signatureOptions, attachments, hardAttachments, brokerOptions} = this.state
        const {signatures} = this.props.options

        let allFieldDisabled = this.isDisabledAllOfTheFields(emailTemplateField, recipientField)

        const isClientProfileModule = (moduleKey == EmailTemplateRelations.EmailTemplateModules.clientsProfile.value)
        brokerFieldIsRequired = isClientProfileModule

        // when we using the broker selector in client profile all field is disabled until a broker is selected
        if (isClientProfileModule) {
            allFieldDisabled = allFieldDisabled || !Boolean(brokerField) || !Boolean(brokerField.value)
        }

        let moduleOptions = (this.state && this.state.moduleOptions) || {}

        let signatureId = signatureField && signatureField.value
        let slectedSignatureDoc = signatures && signatures.filter((item) => item._id == signatureId)
        const signatureHtml = nesProp.get(slectedSignatureDoc, "0.content") || ''
        // force get validation result to skip reactForm reaction delay

        const errors = this.forceValidate()
        attachmentsForValidateOnly.error = errors && errors.attachmentsForValidateOnly
        emailBodyField.error = errors && errors.emailBodyField

        let toSelectCC = nesProp.get(emailToSelectFieldCC, "value") || ''
        // let isCCShown = toSelectCC && Array.isArray(toSelectCC) && toSelectCC.length > 0 ?
        // toSelectCC/* .filter((oneSelectedAddress)=>{return !!oneSelectedAddress.isCC}) */.length > 0 : false
        // isCCShown = isCCShown || this.state.isCCShown
        let isCCShown = !hideCC

        const regExForClientRecipientPrivacy = /(https?:\/\/\S+)/g
        const replacementFunction = (match, i, ofset) => <a href={match} key={match + i}>{match}</a>
        const checkboxDescription = reactStringReplace(_("clientRecipientPrivacyStatement"), regExForClientRecipientPrivacy, replacementFunction)
        const stakeholders =  nesProp.get(this.state, "moduleOptions.stakeholders") || []
        let selectedTemplate = this.getNewSelectedTemplate(emailTemplateField.value)
        let oneSetClear = DSWIZARD_DISCLAIMER_RESTRICTED_TEMPLATE_SET.replace(/[^0-9A-Za-z-_ ]*/g, '')
        let regexpForSet = new RegExp( '^([;\\s]*'+oneSetClear+'[\\s;]*)$|^([\\s;]*'+oneSetClear+'\\s*;)|(;\\s*'+oneSetClear+'\\s*;)|(;\\s*'+oneSetClear+'\\s*)$|(;\\s*'+oneSetClear+'\\s*)$', 'i')
        let haveDisclaimer = selectedTemplate.mailTemplateSet ? (!regexpForSet.test(selectedTemplate.mailTemplateSet)) : true
        this.props.setDisclaimerForPreview(haveDisclaimer)
        let ticketDocuments = nesProp.get(this.state, "moduleOptions.ticketDocuments") || []
        let quickReply = nesProp.get(this.state, "moduleOptions.quickReply") || false

        const isOffice = moduleOptions && moduleOptions.dsPackage && moduleOptions.dsPackage.uploadedOnModule === c.DS_MODULE_OFFICE

        return (
            <div>
                <div className={styles.loginForm}>
                    <form method="post" className={styles.form}>

                        {/*#region [RenderInput]*/}
                        {isClientProfileModule &&
                            <div className={cs(styles.formGroup, styles.marginBottomS)}>
                                <label htmlFor="brokerField" className={styles.formLabel}>
                                    {_("selectBroker")}*
                                </label>
                                <SelectWrapper
                                    className={cs(styles.formInput,styles.sizeL,
                                        (brokerField && brokerField.value ? styles.negativeMarginOne : "")
                                    )}
                                    {...brokerField}
                                    isClearable
                                    options={brokerOptions}
                                    onChange={(value) => (this.onChangeBroker(value))}
                                    onBlur={(e)=>{e.preventDefault()}}
                                />
                            </div>
                        }
                        {/*#endregion*/}
                        {/*#region [RenderError]*/}
                        {isClientProfileModule &&
                            <div className={cs(styles.formGroup,
                                (!brokerField.touched || !brokerField.error ? styles.visibleNone : "")
                            )}>
                                {brokerField.touched && brokerField.error && <div className={styles.errorMessage}>
                                    {brokerField.error}
                                </div>}
                            </div>
                        }
                        {/*#endregion*/}

                        {/*#region [RenderInput]*/}
                        <div className={cs(styles.formGroup, styles.marginBottomS)}>
                            <label htmlFor="emailTemplateField" className={styles.formLabel}>
                                {_("selectTemplate")}*
                            </label>
                            <ReactSelect2
                                className={cs("identificationForTemplateSelector",styles.formInput,styles.sizeL,
                                    (recipientField && recipientField.value ? styles.negativeMarginOne : "")
                                )}
                                styles={{
                                    ...customCreatableSelectStyles,
                                    singleValue: (base, state) => ({
                                        ...base,
                                        minHeight: "16px",
                                        lineHeight: "14px",
                                        fontSize: "1.2em",
                                        color: "#404548",
                                    }),
                                    menuList: base => ({
                                        ...base,
                                        padding: "0.1em",
                                        fontSize: "1.2em",
                                        verticalAlign: "baseline"
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        padding: 0,
                                        fontSize: '1em',
                                        maxHeight: "25px",
                                        display: state.isSelected ? 'none' : 'block',
                                        color: state.isSelected ? 'lightGray' : '#404548',
                                        backgroundColor: 'white',
                                    })
                                }}
                                closeMenuOnScroll={false}
                                components={{DropdownIndicator, NoOptionsMessageForTemplateSelector}}
                                clearable={true}
                                openMenuOnFocus={false}
                                placeholder={''}
                                autofocus={false}
                                options={templatesOptions}
                                onBlurResetsInput={false}
                                isMulti={false}
                                onChange={((value) => {
                                    this.onChangeEmailTemplate(value)
                                })}
                                inputId="templateSelectorSelect1"
                                onBlur={(e)=>{
                                    // this is a fix for an issue of IE11, to disable dropdown autoclose
                                    // when scroll by clicking with cursor on scrollbar
                                    const focusedElement = document.activeElement
                                    const parentClassName = nesProp.get(focusedElement, "parentElement.parentElement.parentElement.className")
                                    let isItSelf = String(parentClassName).includes("identificationForTemplateSelector")

                                    if (isItSelf) {
                                        e.cancelBubbling = true

                                        e.stopPropagation()
                                        //e.stopImmediatePropagation()
                                        e.preventDefault()

                                        e.nativeEvent.cancelBubbling = true

                                        e.nativeEvent.stopPropagation()
                                        e.nativeEvent.stopImmediatePropagation()
                                        e.nativeEvent.preventDefault()
                                        throw null

                                        return false
                                    }
                                }}
                                value={{
                                    value: String(emailTemplateField.value) || '',
                                    label: templatesOptions && templatesOptions.length > 0 &&
                                        templatesOptions.filter((oneTempalte)=>
                                            (String(oneTempalte.value).localeCompare(emailTemplateField.value) === 0)).length > 0 &&
                                        templatesOptions.filter((oneTempalte)=>
                                            (String(oneTempalte.value).localeCompare(emailTemplateField.value) === 0))[0].label  || ''
                                }}
                                filterOption={createFilter({
                                    ignoreCase: true,
                                    ignoreAccents: true,
                                    trim: true,
                                    // matchFrom: 'start',
                                })}
                                isSearchable={true}
                                isDisabled={isClientProfileModule && (brokerField && !brokerField.value)}
                                inputProps={{autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off' }}
                            />
                        </div>
                        {/*#endregion*/}
                        {/*#region [RenderError]*/}
                        <div className={cs(styles.formGroup,
                            (!emailTemplateField.touched || !emailTemplateField.error ? styles.visibleNone : "")
                        )}>
                            {emailTemplateField.touched && emailTemplateField.error && <div className={styles.errorMessage}>
                                {emailTemplateField.error}
                            </div>}
                        </div>
                        {/*#endregion*/}

                        {/*#region [RenderInput]*/}
                        <div className={cs(styles.formGroup, (!emailTemplateField || !emailTemplateField.value) ? styles.visibleNone : "")}>
                            <div className={cs(styles.inARow,styles.recipientContainer)}>
                                {!underscore.isEmpty(templateRecipients) &&
                                    <label className={styles.formLabel}
                                        htmlFor="recipientField">{_("selectRecipient")}*</label>
                                    || null
                                }
                                <div className={styles.recipientButtonsContainer}>
                                    {templateRecipients && templateRecipients
                                        .map((rec, recIndex)=>{
                                            const recipientTranslationKey = 'recipient'+rec.value.charAt(0).toUpperCase() + rec.value.slice(1)
                                            return(
                                                <div key={"recKey"+recIndex} className={styles.recipientButton}>
                                                    <input type={"radio"}
                                                        {...recipientField}
                                                        value={rec.value}
                                                        checked={recipientField.value === rec.value}
                                                        onBlur={(e)=>{ return false }}
                                                        onChange={(value) =>{
                                                            this.onChangeRecipient(value, templateRecipients, templateContent)
                                                            return true
                                                        }}
                                                    />
                                                    <label onClick={(e)=>{
                                                        (this.onChangeRecipient({target: {value: rec.value}}, templateRecipients, templateContent))
                                                    }}>
                                                        {_(recipientTranslationKey)}
                                                    </label>

                                                </div>
                                            )}) ||
                                            (emailTemplateField && emailTemplateField.value &&
                                                <span className={styles}>{_('noRecipientsFound')}</span> || '')
                                    }
                                </div>
                            </div>
                        </div>
                        {/*#endregion*/}

                        {(recipientField.value === EmailTemplateRelations.EmailTemplateRecipients.client.value) &&
                            <div className={cs(styles.formGroup)}>
                                <label className={styles.formLabel}>    </label>
                                <div className={cs(styles.formInput, styles.clientRecipientPrivacyStatementText)}>
                                    {checkboxDescription}
                                </div>
                            </div>
                        }

                        {/*#region [RenderError]*/}
                        <div className={cs(styles.formGroup,
                            (!recipientField.touched || !recipientField.error ? styles.visibleNone : "")
                        )}>
                            {recipientField.touched && recipientField.error && <div className={styles.errorMessage}>
                                {recipientField.error}
                            </div>}
                        </div>
                        {/*#endregion*/}
                        {/*#region [RenderInput]*/}
                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}
                                    htmlFor="emailFromField">
                                    {_("selectFromAddress")}*
                            </label>
                            <SelectWrapper
                                className={cs(styles.formInput,styles.sizeL)}
                                {...emailFromField}
                                options={emailFromOptions}
                                isDisabled={allFieldDisabled && !quickReply}
                                // onBlur={(val) => val}
                                onChange={(value) => (this.onChangeEmailFromAddress(value))}
                                onBlur={(e)=>{e.preventDefault()}}
                            />
                            {/* <label className={cs(styles.formInput,styles.sizeS)}>{selectedEmailFromName}</label> */}
                        </div>
                        {/*#endregion*/}
                        {/*#region [RenderError]*/}
                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}></label>
                            {  (emailFromField.touched && emailFromField.error) &&
                                <div className={styles.errorMessage}>
                                    {emailFromField.error}
                                </div>
                            }
                            {/* {
                                emailServerConfigError && errors.emailFromField &&
                                <div className={styles.errorMessage}>
                                    {errors.emailFromField}
                                </div>
                            } */}
                        </div>
                        {/*#endregion*/}
                        {/*#region [RenderInput]*/}
                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}
                                htmlFor="emailToSelectField">{_("selectToAddress")}*</label>
                            {/*<SelectWrapper
                                className={cs(styles.formInput,styles.sizeMS,styles.marginPlusOne)}
                                {...emailToSelectField}
                                options={emailToOptions}
                                disabled={allFieldDisabled}
                                clearable={true}
                                onChange={(value) => (this.onChangeRecipient Email(value, templateContent))}

                            />*/}
                            <EmailAddressComposer
                                emailToSelectField={emailToSelectField}
                                onChangeRecipientEmail={(inputValue, tContent) => {
                                    let selectedRecipient = fields.recipientField.value
                                    return this.onChangeRecipientEmail(selectedRecipient, inputValue, tContent)
                                }}
                                templateContent={templateContent ? templateContent : {}}
                                emailToOptions={emailToOptions ? emailToOptions.filter((oneSelectedAddress)=>{return !oneSelectedAddress.isCC}) : {}}
                                allFieldDisabled={allFieldDisabled || (this.props.isCreatable === false)}
                                isAnEmail={(email)=>(isAnEmail(email))}
                                isMulti={
                                    (this.props.forceIsMulti === true ? true : (
                                        this.props.forceIsMulti === false ? false : (
                                            (isClientProfileModule ? false : true)
                                        )
                                    ))
                                }
                                isCreatable={
                                    this.props.isCreatable ?
                                        (isClientProfileModule ? false : true)
                                        : false
                                }
                                formatCreateLabel = {_("insertEmailAddresses")}
                                customClassName={cs(styles.creatableSelectInput)}
                                setDeleteItemByOption={(email)=>this.removeRecent(email)}
                                showCCButton={false}
                                onClickCCButton={()=>{this.toggleCCFieldShow()}}
                            />
                            <SelectWrapper
                                className={cs(styles.formInput,styles.sizeXS)}
                                {...emailLanguageField}
                                options={langOptions}
                                isDisabled={allFieldDisabled}
                                onChange={(value) =>
                                    {
                                        let selectedRecipient = fields.recipientField.value
                                        return this.openAskingModalForLanguageChange(selectedRecipient, value, templateContent)
                                    }
                                }
                                onBlur={(e)=>{e.preventDefault()}}
                            />
                        </div>
                        {/*#region [RenderError]*/}
                        <div className={styles.formGroup}>
                            <label className={cs(styles.formLabel,
                                (!emailToSelectField.touched || !emailToSelectField.error ? styles.visibleNone : "")
                            )}></label>
                            {emailToSelectField.touched && emailToSelectField.error && <div className={styles.errorMessage}>
                                {emailToSelectField.error}
                            </div>}
                        </div>
                        {/*#endregion*/}
                        {isCCShown ?
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel} htmlFor="emailToSelectFieldCC">{_("selectToAddressCC")}</label>
                                <EmailAddressComposer
                                    emailToSelectField={emailToSelectFieldCC}
                                    onChangeRecipientEmail={(inputValue, tContent) => {
                                            return (this.onChangeRecipientEmailCC(inputValue, tContent))
                                        }
                                    }
                                    templateContent={templateContent ? templateContent : {}}
                                    emailToOptions={emailToOptions ? emailToOptions : {}}
                                    allFieldDisabled={allFieldDisabled}
                                    isAnEmail={(email)=>(isAnEmail(email))}
                                    isMulti={true}
                                    formatCreateLabel = {_("insertEmailAddresses")}
                                    customClassName={cs(styles.formInput,styles.sizeL)}
                                    setDeleteItemByOption={(email)=>this.removeRecent(email)}
                                />
                            </div>
                            :
                            null
                        }
                        {/*#endregion*/}
                        {/*#region [RenderError]*/}
                        <div className={styles.formGroup}>
                            <label className={cs(styles.formLabel,
                                (!emailToSelectFieldCC.touched || !emailToSelectFieldCC.error ? styles.visibleNone : "")
                            )}></label>
                            {emailToSelectFieldCC.touched && emailToSelectFieldCC.error && <div className={styles.errorMessage}>
                                {emailToSelectFieldCC.error}
                            </div>}
                        </div>
                        {/*#endregion*/}

                        {this.props.options.multiLanguage &&
                        <div className={ cs(styles.formGroup, styles.noMarginBottom)} key="languageSelectorFromGroupKey">
                            <div className={cs(styles.formInput, styles.noMarginRight)}>
                                    <div className={cs(styles.variablesContainer, styles.noMarginRight)}>
                                        {langOptions.filter((oneLang) => {
                                            return stakeholders.some((oneStake) => (oneStake.language === oneLang.value))
                                        }).map(
                                            (oneVar,oneVarIndex) => {
                                                let active = oneVar.value == this.state.activeLanguageTabValue

                                                return (
                                                <div key={"languageIndexOnEmailSender_"+oneVarIndex}
                                                    onClick={(e) => (this.onClickLanguageChangeOfEditor(e, oneVar.value))}
                                                    className={cs(styles.variableTab, styles.languageRow, active ? styles.languageRowActive : "")}>
                                                    {_(oneVar.value)}
                                                </div>)
                                            }
                                        )}
                                        <div key={"languageIndexOnEmailSender_lastline"}
                                            className={cs(styles.variableTab, styles.languageRow, styles.languageRowTopLine)}>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        }
                        <div className={this.props.options.multiLanguage ? styles.multiLanguageTabContent : null}>
                            {/*#region [RenderInput]*/}
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel} htmlFor="recipient">{_("subject")}*</label>
                                <input type={"text"}
                                    className={cs(styles.formInput,styles.formInputText)}
                                    {...subjectField}
                                    disabled={
                                        allFieldDisabled ||
                                        (recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemot.value ||
                                        recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemotProduction.value ||
                                        recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemotClaims.value ||
                                        recipientField.value == EmailTemplateRelations.EmailTemplateRecipients.willemotTarification.value)
                                    }
                                />
                            </div>
                            {/*#endregion*/}
                            {/*#region [RenderError]*/}
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}></label>
                                {subjectField.touched && subjectField.error && <div className={styles.errorMessage}>
                                    {subjectField.error}
                                </div>}
                            </div>
                            {/*#endregion*/}
                            {/*#region [RenderInput]*/}
                            {window.tinymce && this.renderBodyEditor(
                                {
                                    disabled: allFieldDisabled,
                                    templateContent
                                },
                                emailBodyField,
                            )}

                            {/*#region [RenderError]*/}
                            <div className={styles.formGroup}>
                                <label className={cs(styles.formLabel,
                                    (!emailBodyField.touched || !emailBodyField.error ? styles.visibleNone : "")
                                )}></label>
                                {emailBodyField.touched && emailBodyField.error && <div className={styles.errorMessage}>
                                    {emailBodyField.error}
                                </div>}
                            </div>
                            {/*#endregion*/}
                            {/* haveDisclaimer &&
                            <div className={styles.formGroup}>
                                <label className={cs(styles.formLabel)}>{_("disclaimerLabel")}</label>
                                <div className={cs(styles.formInput)}
                                    dangerouslySetInnerHTML={{__html: _("disclaimerText")}}>
                                </div>
                                </div> */}

                        </div>

                        {!isOffice &&
                            <div className={styles.formGroup}>
                                <label className={cs(styles.formLabel, styles.leftRightAlign)}
                                    htmlFor="signatureField">
                                    <span>{_("signature")}</span>
                                    <span>
                                        <a href={"/office/signature"} onClick={(e) => {
                                            e.preventDefault()
                                            if (confirm(_("areYouSureToLeaveThisPage"))) {
                                                this.navigateToSignature()
                                            }
                                        }} target="_self">
                                            <img src={this.getIcon('a-edit_1x_blue.svg')} alt={_('goToManageSignatures')} />
                                        </a>
                                    </span>
                                </label>
                                <SelectWrapper
                                    className={cs(styles.formInput)}
                                    {...signatureField}
                                    isClearable
                                    options={signatureOptions}
                                    isDisabled={allFieldDisabled}
                                    onBlur={(e) => { e.preventDefault() }}
                                />
                            </div>
                        }
                        {/*#endregion*/}
                        {/*#region [RenderInput]*/}
                        {!isOffice &&
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel}></label>
                                <div className={cs(styles.formInput, styles.signature)}
                                    dangerouslySetInnerHTML={{ __html: signatureHtml }}
                                />
                            </div>
                        }
                        {/*#endregion*/}
                        {(!underscore.isEmpty(attachments) || !underscore.isEmpty(hardAttachments)) &&
                        <div className={cs(styles.formGroup,styles.attachmentsFormGroup)}>
                            {this.renderAttachmentsLabel()}
                            {this.renderAttachments()}
                        </div>}
                        {/*#region [RenderError]*/}
                        <div className={cs(styles.formGroup,
                            (!attachmentsForValidateOnly.error ? styles.visibleNone : "")
                        )}>
                            <label className={styles.formLabel}></label>
                            {attachmentsForValidateOnly.error && <div className={styles.errorMessage}>
                                {attachmentsForValidateOnly.error}
                            </div>}
                        </div>
                        {/*#endregion*/}
                        {(underscore.isEmpty(attachments) && underscore.isEmpty(hardAttachments)) &&
                        <div className={cs(styles.formGroup)}>
                            {this.renderAttachmentsLabel()}
                            <div className={cs(styles.formInput, styles.noAttachmentText)}>
                                {_("noAttachemntsSelected")}
                            </div>
                        </div>}
					</form>
                </div>
                {/*#region [Helpers]*/}
                <ConfirmationDialog
                    modalIsOpen={emailConfModalIsOpen}
                    cancelLabel={_("cancel")}
                    confirmationLabel={_("ok")}
                    onCancel={()=>{
                        const {dispatch} = this.props
                        dispatch(hideEmailSenderConfirmationModal("emailConfModal", false))
                    }}
                    onConfirmation={async ()=>{
                        const {dispatch, options: {confirmationModal}} = this.props
                        const flag = confirmationModal && confirmationModal.flag || ''
                        let recipient =  fields.recipientField.value
                        switch(flag) {
                            case "changeTemplate": {
                                this.doTheTemplateSwitch(moduleOptions.brokerNumber,  moduleOptions.clientLanguage)
                                break
                            }
                            case "changeRecipient": {
                                this.doTheRecipientSwitch()
                                break
                            }
                            case "changeLanguage": {
                                this.doTheLanguageChange(recipient)
                                break
                            }
                            case "changeBroker": {
                                await this.doTheBrokerChange(moduleOptions)
                                this.setState({moduleOptions})
                                break
                            }
                        }
                        await dispatch(hideEmailSenderConfirmationModal("emailConfModal", true))
                    }}
                />
                <ConfirmationDialog
                    modalIsOpen={emailSentModalIsOpen}
                    cancelLabel={_("goToOutbox")}
                    confirmationLabel={_("ok")}
                    onCancel={()=>{
                        const {dispatch} = this.props
                        dispatch(setEmailSenderModule(''))
                        dispatch(hideEmailSenderModal())
                        this.navigateToOutbox()

                        // fire callback of the emailer button parent component
                        if (typeof this.props.onSentLate === 'function') {
                            this.props.onSentLate(nesProp.get(emailSentModal, "payload"))
                        }
                    }}
                    onConfirmation={()=>{
                        const {dispatch, options: {confirmationModal}} = this.props
                        const flag = confirmationModal && confirmationModal.flag || ''

                        dispatch(setEmailSenderModule(''))
                        dispatch(hideEmailSenderModal())

                        // fire callback of the emailer button parent component
                        if (typeof this.props.onSentLate === 'function') {
                            this.props.onSentLate(nesProp.get(emailSentModal, "payload"))
                        }
                    }}
                    contentData={emailSentModal}
                />
                <ConfirmationDialog
                    modalIsOpen={emailNotSentModalIsOpen}
                    confirmationLabel={_("ok")}
                    onConfirmation={()=>{
                        const {dispatch, options: {confirmationModal}} = this.props
                        const flag = confirmationModal && confirmationModal.flag || ''
                        dispatch(hideEmailSenderConfirmationModal("emailNotSentModal", true))
                    }}
                />
                <ConfirmationDialog
                    modalIsOpen={waitingModalIsOpen}
                    options={{noButtons: true}}
                />
                <AttachmentDialog
                    cancelLabel={_("cancel")}
                    confirmationLabel={_("ok")}
                    onCancel={()=>{
                        const {dispatch} = this.props
                        dispatch(hideEmailSenderAttachmentModal(false))
                    }}
                    onConfirmation={(result0=[], result1=[], result2=[], result3=[], result4=[])=>{
                        const {dispatch, options: {attachmentModal}} = this.props
                        const flag = attachmentModal && attachmentModal.flag || ''

                        switch(flag) {
                            case "attach": {
                                this.handleConfirmSelectedAttachments(result0, result1, result2, result3, result4)
                                break
                            }
                        }
                        dispatch(hideEmailSenderAttachmentModal(true))
                    }}
                    moduleOptions={moduleOptions}
                    moduleKey={moduleKey}
                    selected0={this.state.moduleSpecificClaimAttachemnts}
                    selected1={this.state.moduleSpecificContractAttachemnts}
                    selected2={this.state.moduleSpecificClientAttachemnts}
                    selected3={this.state.moduleSpecificTarificationAttachemnts}
                    selected4={this.state.moduleSpecificTicketAttachemnts}
                    ticketDocuments={ticketDocuments}
                />
                <ConfirmationDialog
                    modalIsOpen={showPreviewModal}
                    confirmationLabel={_("ok")}
                    onConfirmation={()=>{
                        const {dispatch} = this.props
                        dispatch(hideEmailSenderConfirmationModal("previewModal", true))
                    }}
                    options={{email: this.state.finalEmail, showPrintButton: true, printButtonLabel: _("print")}}
                />
                {/*#endregion*/}
			</div>
		)
	}
}

/**
 * This is the master Email sender component. Used for compose and send emails.
 */
@connect((state) => ({
    lang: state.app.lang,
    userId: state.app.userId,
    EmailTemplateRelations: state.app.security.EmailTemplateRelations,
    office: state.office,
    brokers: state.office.brokers,
    files: state.files,
    confirmationModal: state.emailSender.confirmationModal,
    attachmentModal: state.emailSender.attachmentModal,
    emailConfModalIsOpen: state.emailSender.emailConfModalIsOpen,
    // emailSentModalIsOpen: state.emailSender.emailSentModalIsOpen,
    emailNotSentModalIsOpen: state.emailSender.emailNotSentModalIsOpen,
    waitingModalIsOpen: state.emailSender.waitingModalIsOpen,
    showPreviewModal: state.emailSender.showPreviewModal,
    externalAttachments: state.emailSender.externalAttachments,
    emailServerConfigModalIsOpen: state.emailSender.emailServerConfigModalIsOpen,
    serverConfigIsSaved: state.emailSender.serverConfigIsSaved,
}))
export default class EmailSenderModal extends React.Component {
	static propTypes = {
        dispatch: React.PropTypes.any,
        templates: React.PropTypes.array.isRequired,
        signatures: React.PropTypes.array,
        recipientWillemotEmails: React.PropTypes.array,
        lang: React.PropTypes.string,
        moduleKey: React.PropTypes.string.isRequired,
        moduleOptions: React.PropTypes.object,
        EmailTemplateRelations: React.PropTypes.any,
        contractManagerLanguage: React.PropTypes.string,
        contractManagerMail: React.PropTypes.string,
        claimsManagersDetails: React.PropTypes.array,
        office: React.PropTypes.any,
        files: React.PropTypes.any,
        externalAttachments: React.PropTypes.any,
        onSent: React.PropTypes.func,
        onSentLate: React.PropTypes.func,
        modalId: React.PropTypes.string,
        hideCC: React.PropTypes.bool,
        multiLanguage: React.PropTypes.bool,
        serialSending: React.PropTypes.bool,
        getDSStakeholders: React.PropTypes.func,
        isCreatable: React.PropTypes.bool,
        forceIsMulti: React.PropTypes.bool,
        onCancel: React.PropTypes.func
    }

    haveDisclaimer = false

    constructor(props) {
        super(props)

        this.state = {
            email: {
                senderEmail: '', cleanSenderEmail: '', to: '', subject: '', message: '', attachments: [],
                recipient: '', templateIndexType: '', templateLowValue: '', templateTitle: '', templateAbbr: '',
                clientId: '', contractId: '', claimId: '', signatureId: false, sendingButtonDisabled: false,
            },
            hasErrors: false,
            emailSentModalIsOpen: false
        }
    }

    /**
     * This function handle the touch event, to trigger blur.
     * @param {*} field
     */
    touch(field) {
        field.onBlur()
    }

    /**
     * this function has been modified, now it checks if email server settings has senderName parameter
     * If it dosent a configuration modal will be opened where it can be configured, afterward the sending process will continue normaly
     */
    modalEmailSend() {
        const {dispatch} = this.props

        const senderEmailFieldValue = this.state.email.senderEmail
        dispatch(loadEmailServer(senderEmailFieldValue))
        .then(async res => {
            if( res && res.senderName && res.senderName.length > 0 ) {
                await this.sendEmail()
            } else {
                dispatch(showEmailServerConfigModal(senderEmailFieldValue))
            }
        }).catch(err => {
            dispatch(showEmailServerConfigModal(senderEmailFieldValue))
        })
    }

    /**
     * This function will open the notification modal after email sending.
     * From here you can navigate to outbox.
     */
    async sendEmail() {
        const {dispatch, onSent, serialSending, multiLanguage, lang} = this.props

        // async, just disable the buton on next render
        this.setState({sendingButtonDisabled: true})

        try {
            // result of the responses
            let response = []
            // handle multi email sending
            if (serialSending) {
                let stakeholderMap = this.state.email.moduleOptions.stakeholders.map((item)=>{
                    return {stakeholder: item._id}
                })

                let stakeholders = await this.props.getDSStakeholders(stakeholderMap)
                let originalConfig  = JSON.parse(JSON.stringify(this.state.email))
                let tos = originalConfig.to.split(";")

                // NOTICE cc-s not supported while serial sending email (skipped), normally CC is disabled in this case.

                // iterating the recipients to send email one by one on serial mode
                for(let i = 0; i < tos.length; i++) {
                    let oneTo = tos[i]

                    // clone the settings to modify it for indepentdent dsendings.
                    let cloneConfig = JSON.parse(JSON.stringify(originalConfig))

                    // overwrite the recipient temporary
                    cloneConfig.to = oneTo


                    //the email addresses in the to is muts be raw email addresses all the time, no decorations like name<...> so on.
                    let stakeholder = stakeholders.find(
                        (oneStake) => (String(oneStake.email).trim() === String(oneTo).trim())
                    )

                    if (!stakeholder) {
                            console.error("No stakeholder found to detect the language for recipient. Fall back to nl. all stakholder: ",
                            stakeholders,
                            "one to address ",oneTo
                        )
                    }

                    // determine the language
                    let oneStakeLang = stakeholder ? String(stakeholder.language).toLowerCase() : 'nl'
                    let instantVariables = []

                    // overwrite the content and subject of the email
                    // when the multilanguage switch is on, working only when serial sending is on
                    if (multiLanguage) {
                        cloneConfig.message =  oneStakeLang === 'nl' ? cloneConfig.nlMessage : cloneConfig.frMessage
                        cloneConfig.subject =  oneStakeLang === 'nl' ? cloneConfig.nlSubject : cloneConfig.frSubject
                        const link = stakeholder.privateLink

                        // preaprea personalised variable values for stakeholders
                        instantVariables.push(
                            {
                                value: _(DSWIZARD_PRIVATE_LINK_PLACEHOLDER_TRANS_KEY, oneStakeLang),
                                fetchValue: link
                            }
                        )

                        instantVariables.push(
                            {
                                value: _(DSWIZARD_RECIPIENT_NAME_PLACEHOLDER_TRANS_KEY, oneStakeLang),
                                fetchValue: stakeholder.firstName + " " +stakeholder.lastName
                            }
                        )

                    }

                    // preplace instant variabels only in body
                    instantVariables.forEach((onVar) => {
                        cloneConfig.message = String(cloneConfig.message).replaceAll(onVar.value, onVar.fetchValue)
                    })

                    // add disclaimer
                    cloneConfig.message = cloneConfig.message
                    cloneConfig.disclaimerHtml = this.haveDisclaimer ? _("disclaimerText", oneStakeLang) : ""

                    // send one email from one recipient
                    let oneEmailResult = await dispatch(sendEmailBySender(cloneConfig))

                    response.push(oneEmailResult)
                }

            }
            else // single email sending for all recipients
            {

                let language = this.state.email.moduleOptions.clientLanguage || lang

                let originalConfig  = JSON.parse(JSON.stringify(this.state.email))
                originalConfig.message = originalConfig.message
                originalConfig.disclaimerHtml = (this.haveDisclaimer ? _("disclaimerText", language) : "")

                let oneResult = await dispatch(sendEmailBySender(originalConfig))

                response.push(oneResult)
            }

            this.setState({
                emailSentModal: {
                    modalId: "emailSentModal",
                    title: _("emailSent"),
                    message: _("emailSentMessage"),
                    flag: "emailSent",
                    payload: response,
                },
                emailSentModalIsOpen: true
            })

            // refreshing the outbox
            await dispatch(getOutbox(true))

            // fire callback of the emailer button parent component
            if (typeof onSent === 'function') {
                onSent(response)
            }
        } catch(err) {
            console.error(err)

            let messageForErrorModal = _("emailNotSentMessage") + ' "' + (nesProp.get(err, "error.errorMessage") || JSON.stringify(err)) + '"'

            //added a check in case error from server is "{}", maybe we should change the emailNotSentMessage to its own translation case error is from server
            if (nesProp.get(err, "error.data.code")*1 == 2 && nesProp.get(err, "error.data.error") !== "{}") {
                messageForErrorModal = _("emailNotSentMessage") + ' "' + JSON.stringify(nesProp.get(err, "error.data.error")) + '"'
            }

            dispatch(showEmailSenderConfirmationModal(
                "emailNotSentModal",
                _("emailNotSentTitle"),
                messageForErrorModal,
                "emailSent",
                null
            ))
        }

        this.setState({sendingButtonDisabled: false})
    }

    /**
     * Callback function given for email composer, to actualize the current email content in this module
     * @param {Object} email - Full email content object
     */
    actualizeEmailContent(email) {
        this.setState({email: {...email}})
    }

    /**
     * Event to leave the email sender modal.
     */
    goBack() {
		const {dispatch, onCancel} = this.props
        dispatch(hideEmailSenderModal())
        dispatch(setEmailSenderModule(''))
        if (onCancel) {
            onCancel()
        }
    }

    modalPreviewEmail() {
        const {dispatch} = this.props
        const {email} = this.state

        let html =
        '<div style="display: felx; flex-direction: column;">'+
            '<div style="flex-flow: row nowrap; align-items: flex-start;">'+
                '<span style="display: inline-block; width: 20%;">'+_("subject") + ': </span> <span style="flex: 5; word-break: break-all;">' + email.subject + "</span>" +
            '</div>' +
            '<div style="flex-flow: row nowrap; align-items: flex-start;">'+
                '<span style="display: inline-block; width: 20%;">'+_("selectFromAddress") + ': </span> <span style="flex: 5; word-break: break-all;">' + email.senderEmail + "</span>" +
            '</div>' +
            '<div style="flex-flow: row nowrap; align-items: flex-start;">'+
                '<span style="display: inline-block; width: 20%;">'+_("selectToAddress") + ': </span> <span style="flex: 5; word-break: break-all;">' + email.to + "</spans>" +
            '</div>' +
        '</div>' + '<hr/>' +
        email.message + email.signatureHtml + email.disclaimerHtml


        dispatch(showEmailSenderConfirmationModal(
            "previewModal",
            email.subject, // modal title
            html,
            "",
            null
        ))
    }

	render() {
        const {dispatch, emailServerConfigModalIsOpen} = this.props
        const {sendingButtonDisabled, showPreviewModal} = this.state

		return (
            <div key={"emailSenderModalMainContainerKey"}>
				<div className={styles.title} key={"emailSenderModalMainContainerTitleKey"}>{_('emailSenderTitle')}</div>
				<div className={styles.contentWrapper} key={"emailSenderModalMainContainerWrapperKey"}>
					<div className={styles.content} key={"emailSenderModalContentKey"}>
                        <SenderForm
                            goBack={() => this.goBack()}
                            options={{
                                ...this.props,
                                moduleOptions: this.props.moduleOptions,
                                hasErrors: this.state.hasErrors,
                                emailSentModal: this.state.emailSentModal,
                                emailSentModalIsOpen: this.state.emailSentModalIsOpen
                            }}
                            dataCallback={(email) => {this.actualizeEmailContent(email)}}
                            dataCallbackDisableSend={(error) => {
                                if (!!error !== !!this.state.hasErrors) {
                                    this.setState({hasErrors: Boolean(error)})
                                }
                            }}
                            setDisclaimerForPreview={(newHaveDisclaimer)=>{
                                this.haveDisclaimer = newHaveDisclaimer
                            }}
                            onSentLate={() => {
                                this.setState({
                                    emailSentModal: false,
                                    emailSentModalIsOpen: false
                                })

                                if (typeof this.props.onSentLate === 'function') {
                                    this.props.onSentLate(this.state.emailSentModal.payload)
                                }

                            }}
                            isCreatable={this.props.isCreatable}
                            forceIsMulti={this.props.forceIsMulti}
                            haveDisclaimer={this.haveDisclaimer}
                        />
                    </div>
                    <div className={styles.buttons} key={"emailSenderModalButtonsListsKey"}>
                        <div
                            key={"emailSenderModalButtonsCancelKey"}
                            onClick={() => this.goBack()}
                            className={cs(styles.cancelButton)}
                        >
                            {_('cancel')}
                        </div>
                        <div
                            key={"emailSenderModalButtonsSendKey"}
                            onClick={(e) => {
                                e.preventDefault()
                                if (this.state.hasErrors || sendingButtonDisabled) {
                                    return
                                }
                                this.modalEmailSend()
                            }}
                            className={cs(styles.next, (this.state.hasErrors ? styles.disabled : styles.enabled))}
                        >
                            {_('sendEmail')}
                        </div>
                        <div
                            key={"emailSenderModalButtonsPreviewKey"}
                            onClick={(e) => {
                                e.preventDefault()
                                if (this.state.hasErrors || sendingButtonDisabled) { return }
                                this.modalPreviewEmail()
                            }}
                            className={cs(styles.next, (this.state.hasErrors ? styles.disabled : styles.enabled))}
                        >
                            {_('previewEmail')}
                        </div>
					</div>
				</div>
                <EmailServerConfigDialog
                    modalIsOpen={emailServerConfigModalIsOpen}
                    onCancel={()=>{
                        const {dispatch} = this.props
                        dispatch(hideEmailServerConfigModal(false))
                    }}
                    onConfirmation={(config)=>{
                        dispatch(saveEmailServer(config)).then(res => {
                        dispatch(hideEmailServerConfigModal(true))
                            if(res){
                                this.sendEmail()
                            }
                        })
                    }}
                />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/emailSender/emailSenderModal.jsx